/* dropzone */

function initializeDropzone(dropzoneId, callback) {
    // CSS styling
    $('#' + dropzoneId)
        .on('dragover dragenter', function () {
            $('#' + dropzoneId).addClass('div-is-dragover');
        })
        .on('dragleave dragend drop', function () {
            $('#' + dropzoneId).removeClass('div-is-dragover');
        });

    // patient context
    // check if the documents are loaded in a specific patient context (patient view)
    var currentPatientContextId = $('#currentPatientContextId').val();

    // Get the template HTML and remove it from the document
    var previewNode = document.querySelector('#templateFor' + dropzoneId);
    previewNode.id = '';
    var previewTemplate = previewNode.parentNode.innerHTML;
    previewNode.parentNode.removeChild(previewNode);

    var myDropzone = new Dropzone('#' + dropzoneId, {
        url: '/' + appLocation + 'dropDocument',
        method: 'post',
        paramName: 'file',
        previewTemplate: previewTemplate,
        maxFilesize: 50, //MB
        autoQueue: false,
        previewsContainer: '#previewsFor' + dropzoneId,
        parallelUploads: 1,
        clickable: false,
        autoDiscover: false,
    });

    myDropzone.on('addedfile', function (file) {
        $('#dragAndDropFileUploadFor' + dropzoneId).show();
        //TODO: Nicetohave Client site date extraction  on drop
        //     extractDataFromFile(file, function (allMetadata) {
        //         // console.log(myDropzone, allMetadata);
        //     });
    });

    if (callback == 'attachDocumentsInMessage') {
        myDropzone.on('sending', function (file, xhr, formData) {
            formData.append('documentTypeId', $('#selectDocumentTypeDivFor' + dropzoneId + '> select').val()); // Append all the additional input data of your form here!
            formData.append('isSigned', $('#isSignatureFor' + dropzoneId).is(':checked'));
            formData.append('authorId', $(file.previewElement).find('[name=\'authorId\']').val());

            if ($('#messageReceiverValue').val() != null) {
                //the receiver id is 0 when no receiver is selected yet
                formData.append('patientId', $('#messageReceiverValue').val());
            }
        });
    } else if (callback == 'findingList') {
        myDropzone.on('sending', function (file, xhr, formData) {
            formData.append('documentTypeId', -97); // Append all the additional input data of your form here!
            formData.append('isSigned', false);

            if ($('#dropzoneFindingAuthorValue').val() != null) {
                //the patient id is 0 when no receiver is selected yet
                formData.append('authorId', $('#dropzoneFindingAuthorValue').val());
            }
            if ($('#dropzoneFindingPatientValue').val() != null) {
                //the patient id is 0 when no receiver is selected yet
                formData.append('patientId', $('#dropzoneFindingPatientValue').val());
            }
            if ($('#dropzoneFindingReferringDoctorValue').val() != null) {
                //the ReferringDoctor id is 0 when no receiver is selected yet
                formData.append('referringDoctorId', $('#dropzoneFindingReferringDoctorValue').val());
            }
        });
    } else {
        myDropzone.on('sending', function (file, xhr, formData) {
            formData.append('documentTypeId', $('#selectDocumentTypeDivFor' + dropzoneId + '> select').val()); // Append all the additional input data of your form here!
            formData.append('isSigned', $('#isSignatureFor' + dropzoneId).is(':checked'));

            formData.append('authorId', $(file.previewElement).find('[name=\'authorId\']').val());

            if (currentPatientContextId != -1) {
                formData.append('patientId', currentPatientContextId);
            }
        });
    }

    // Update the total progress bar
    myDropzone.on('totaluploadprogress', function (progress, bytesSent) {
        if (bytesSent > 0)
            //don't set to 100 if one file is deleted
            document.querySelector('#total-progressFor' + dropzoneId + ' .progress-bar').style.width = progress + '%';
    });

    //if drag and drop is applied direct in message
    if (callback == 'attachDocumentsInMessage') {
        //parameter file is the uploaded file, response returns the new document (from Controller)
        myDropzone.on('success', function (file, response) {
            if (response.status == 'SUCCESS') {
                actionSuccess();

                var attachment = attachments.push({
                    id: response.result.id, name: response.result.name, date: 'Neu', idSuffix: '',
                });

                //append it to html container and increase attachment count (hidden input id)
                appendAttachment(attachments[attachment - 1]);
                attachmentCount++;
            } else if (response.status == 'DOCUMENT-WRONG-MIMETYPE-ERROR') {
                actionFail('Ungültiges Dateiformat!');
            } else {
                actionFail('Unerwarteter Fehler: ' + response.status);
            }
        });
    } else {
        myDropzone.on('success', function (file, response) {
            if (response.status == 'SUCCESS') {
                actionSuccess();
            } else if (response.status == 'DOCUMENT-WRONG-MIMETYPE-ERROR') {
                actionFail('Ungültiges Dateiformat!');
            } else if (response.status == 'NO-AUTHOR-ERROR') {
                actionFail('Kein Autor ausgewählt!');
            } else {
                actionFail('Unerwarteter Fehler: ' + response.status);
            }
        });
    }

    // Hide the total progress bar when nothing's uploading anymore
    myDropzone.on('queuecomplete', function () {
        //what happens depends on where the drop filezone is used (noticed by parameter in th:fragment)
        if (callback == 'attachDocuments') {
            loadDocumentsForAttachments();
        }
        // if we are in the normal document list (documents module) check if the list is loaded in patient context (patientView for doctor)
        else if (callback == 'documentList') {
            if (currentPatientContextId != -1) {
                loadById('Documents', currentPatientContextId);
            } else {
                load('Documents');
            }
        } else if (callback == 'findingList') {
            if (currentPatientContextId != -1) {
                loadById('Findings', currentPatientContextId);
            } else {
                load('Findings');
            }
        } else if (callback == 'attachDocumentsInMessage') {
            //just hide
        }

        //no matter where - the file upload always get hidden in the end
        $('#dragAndDropFileUploadFor' + dropzoneId).fadeOut(1000, function () {
            myDropzone.removeAllFiles();
            document.querySelector('#total-progressFor' + dropzoneId + ' .progress-bar').style.width = '0%';
        });
    });

    // Setup the buttons for all transfers
    // The "add files" button doesn't need to be setup because the config
    // `clickable` has already been specified.
    document.querySelector('#actionsFor' + dropzoneId + ' .start').onclick = function () {
        myDropzone.enqueueFiles(myDropzone.getFilesWithStatus(Dropzone.ADDED));
    };
    document.querySelector('#actionsFor' + dropzoneId + ' .cancel').onclick = function () {
        $('#dragAndDropFileUploadFor' + dropzoneId).fadeOut(500, function () {
            myDropzone.removeAllFiles(true);
            document.querySelector('#total-progressFor' + dropzoneId + ' .progress-bar').style.width = '0%';
        });
    };
}

/*START OF SENDING ATTACHMENTS*/
var attachmentCount = 0; //running counter to increase hidden input id
var attachments = []; //array for all attached elements - necessary when user deletes some of them

/* idSuffix is used to attach documents in reply messages - problem was that there are multiple attachment-divs on one page - use baseMessageId as id suffix
 * - the NewMessage dialog and the attachments in new concerns submit nothing (null) to the function, no suffix (is ok, because only one per page possible) */
function loadDocumentsForAttachments(baseMessageId, userContextId, callback, selectionId, maxLength) {
    const idSuffix = baseMessageId ? baseMessageId : '';
    const selectionIdSuffix = selectionId ? `/${selectionId}` : '';
    const loadingUrl = userContextId && userContextId != -1 ? `getDocumentsForAttachments/${userContextId}${selectionIdSuffix}` : 'getDocuments';
    const block = `.SelectFromDocumentsBlock` + (selectionId ? selectionId : '')

    showLoaderIn(block);

    $(block).load('/' + appLocation + loadingUrl, () => {
        let myNewDocumentsTableId = baseMessageId || 'myNewDocumentsTableId';
        //rename the datatableId because the id is not unique in patient view. there are documents and the documents list to attach in new messages
        $(block).find('table').attr('id', myNewDocumentsTableId);

        if ($.fn.DataTable.isDataTable($(`#${myNewDocumentsTableId}`))) {
            $(`#${myNewDocumentsTableId}`).DataTable().clear().destroy();
        }
        try {
            orderByColumn = $(`#${myNewDocumentsTableId}`).find('tr .sort_by').index();
        } catch (e) {
            orderByColumn = undefined;
        }
        var dataTable = datatableMe(myNewDocumentsTableId, {style: 'multi'}, orderByColumn);
        //hide the actions column (class hideForAttachmentSelection)
        dataTable.column('.hideForAttachmentSelection').visible(false);
        //remove the old dataTable from the button
        $('#attachButton').unbind('click');
        $('#attachButton').click(function () {
            attach(dataTable.rows('.selected').data(), idSuffix, maxLength);
        });
        callback?.();
    });
}

//modal for attachments
function showAttachmentModal(baseMessageId, userContextId, maxLength) {
    $('#AttachmentModalReplace').load('/' + appLocation + 'getAttachmentModal', () => {
        $('#AttachmentModal').modal({backdrop: 'static', keyboard: false});
        loadDocumentsForAttachments(baseMessageId, userContextId, undefined, undefined, maxLength);
    });
}

//called from 'attach now' in attachment modal, after the user selected the elements he wishes to attach
function attach(data, idSuffix, maxLength) {
    if (data.count() == 0) {
        alert('Keine Dokumente ausgewählt');
    } else {
        data.each(function (data) {
            //save attachment to attachments array (necessary to delete)
            var attachment = attachments.push({
                id: data[0], name: data[2], date: data[3], idSuffix: idSuffix,
            });

            //append it to html container and increase attachment count (hidden input id)
            appendAttachment(attachments[attachment - 1], maxLength);
            attachmentCount++;
        });
        //hide modal after all attachments have been inserted
        $('#AttachmentModal').modal('hide');
    }
}


// append an attachment to the attachment list (div id=attachments)
function appendAttachment(attachment, maxLength) {
    let tooLong = "";
    try {
        if (maxLength && maxLength > 0) {
            const name = $(attachment.name).attr("data");
            tooLong = name && name.length >= 50 ?
                `<div class="row" style="color: red;padding-bottom: 1em;padding-top: 0.5em">
            <span class="glyphicon glyphicon-ban-circle" aria-hidden="true" title="Titel ist zu lang"></span>&nbsp;<span >Der Titel des Dokuments ist zu lang (${name.length}/50)!</span>
        </div>` : ""
        }
    } catch (e) {
        console.error("Could not determine length of Document Name", e);
    }
    $('#attachments' + attachment.idSuffix)
        .append(`<div class="col-xs-12" id="attachment${attachment.idSuffix}${attachmentCount}">
            <span>${attachment.name} (${attachment.date}) </span>&nbsp;` +
            '<button type="button" class="btn btn-link" onclick="removeAttachment(' + attachment.id + ',\'' + attachment.idSuffix + '\');">' +
            `<span style="color:dimgrey;" class="glyphicon glyphicon-remove"></span>
            </button>
            <input type="hidden" value="${attachment.id}" name="attachments['${attachmentCount}']" id="attachments${attachmentCount}"/>
            ${tooLong}
            </div>`);
}

function removeAttachment(attachmentToRemoveId, attachmentToRemoveIdSuffix) {
    //remove all attachments (necessary because missing hidden input ids cause an error in controller mapping)
    attachments.forEach(function (attachment, index) {
        $('#attachments' + attachment.idSuffix).empty();
    });

    //reset attachment count and recreate all (but the deleted) attachments
    attachmentCount = 0;
    var spliceIndex;

    attachments.forEach(function (attachment, index) {
        //find the element to delete
        if (attachment.id == attachmentToRemoveId) {
            //don't delete the element while doing the foreach - buggy - just remember where to splice (delete)
            spliceIndex = index;
        }
        //all other elements are attached
        else {
            appendAttachment(attachment);
            attachmentCount++;
        }
    });

    //finally delete the attachment from the attachments array
    attachments.splice(spliceIndex, 1);
}

function attachNewDocument(receiverId, baseMessageId, maxLength) {
    $('#DocumentsModalReplace').load('/' + appLocation + 'getDocumentsModal/0/0', function () {
        //TODO: in the patient view are two elements in with id="patientId"
        // one in the DocumentsModal, another in the NewPatientRecordForm
        // -> rename one of them

        //try to preselect document createdFor with current message receiver
        $('select#patientId').val(receiverId);
        if ($('select#patientId').val() == null) $('select#patientId').val(null); //if no receiver was found, reset it to null to show selected "Allgemein"

        $('#DocumentsModal').modal({backdrop: 'static', keyboard: false});
        registerAttachNewDocumentButton(baseMessageId, maxLength);
    });
}

function registerAttachNewDocumentButton(baseMessageId, maxLength) {
    //Submit new Document in Modal
    $('#newDocumentForm').submit(function (e) {
        //prevent double submitting
        var submitButtonId = 'documentModalSubmitButton';
        var oldButtonText = setButtonInWaitingMode(submitButtonId);

        //remove old error messages after resubmit
        $('.error-msg').remove();
        $('#error-msg-document-form').hide();

        var myForm = new FormData(this);

        $.ajax({
            url: $(this).attr('action'),
            context: document.body,
            type: 'post',
            data: myForm,
            cache: false,
            contentType: false,
            processData: false,
        })
            .done(function (response) {
                $('#error-msg-document-form').show('fast');
                showAjaxResponse(response, 'document', 'DocumentsModal');

                if (response.status == 'SUCCESS') {
                    $('#DocumentsModal').modal('hide');
                    if (baseMessageId) var idSuffix = baseMessageId; else var idSuffix = '';
                    var attachment = attachments.push({
                        id: response.result.id, name: response.result.name, date: 'Neu', idSuffix: idSuffix,
                    });

                    //append it to html container and increase attachment count (hidden input id)
                    appendAttachment(attachments[attachment - 1], maxLength);
                    attachmentCount++;
                } else {
                    wakeButtonFromWaitingMode(submitButtonId, oldButtonText);
                }
            })
            .fail(function (error) {
                $('#error-msg-document-form').show('fast');
                showAjaxError(error, 'document');
                wakeButtonFromWaitingMode(submitButtonId, oldButtonText);
            });
        return false;
    });
}

/*END OF ATTACHMENTS*/

//load any document to sign - callback function is called when document was successfully signed (finish-button-clicked)
function loadDocumentToSign(id, callbackSuccess, callbackCancel) {
    //load and show the modal
    $('#SignDocumentModalReplace').load('/' + appLocation + 'getDocumentToSign/' + id, function () {
        $('#SignDocumentModal').modal({keyboard: false});

        //register the action for the finish button
        if (callbackSuccess != null && typeof callbackSuccess === 'function') {
            $('#finishButton').click(function () {
                $('#documentIsSigned').val('true');
                $('#SignDocumentModal').modal('hide');
                //execute callback from the calling method
                callbackSuccess();
            });
        } else {
            //default action what should happen when a document has been signed
            $('#finishButton').click(function () {
                $('#documentIsSigned').val('true');
                $('#SignDocumentModal').modal('hide');
                reloadCurrentContent();
            });
        }

        //when the signing modal got closed (either with clicking anywhere outside the modal, clicking the close icon, or clicking one of the two buttons)
        $('#SignDocumentModal').on('hidden.bs.modal', function (e) {
            //check if the temp documents are deleted already
            if ($('#somethingToDelete').val() == 'yes') {
                $.ajax({
                    url: '/' + appLocation + 'deleteTempFiles',
                    context: document.body,
                    type: 'post',
                    data: {documentId: id},
                })
                    .done(function () {
                        //don't show anything to the user
                    })
                    .fail(function () {
                        actionFail();
                    });
            }
            //check if the user aborted the signing process
            if ($('#documentIsSigned').val() != 'true') {
                //execute the action for the cancel button
                if (callbackCancel != null && typeof callbackCancel === 'function') {
                    //execute callback from the calling method
                    callbackCancel();
                } else {
                    //default behaviour: reload current content when document was not signed
                    //Wieso es hat sich ja nicht geaendert ?
                    // reloadCurrentContent();
                }
            }
        });
    });
}

function loadDocument(documentId) {
    $.ajax({
        url: '/' + appLocation + 'duplicateDocumentToSign',
        context: document.body,
        type: 'post',
        data: {documentId: documentId},
    }).done(function (response) {
        $('#somethingToDelete').val('yes');
        let result = JSON.parse(response.result);
    });
}

function loadPdfDocumentToSign(documentId) {
    $.ajax({
        url: '/' + appLocation + 'duplicateDocumentToSign',
        context: document.body,
        type: 'post',
        data: {documentId: documentId},
    }).done(function (response) {
        let result = JSON.parse(response.result);
        // const pdfViewer = new PdfViewer({
        //     pdfData: result.documentToSignURL,
        //     placeholderCoordinates: result.signatureCoordinates,
        //     selector: "#viewport"
        // });
        // pdfViewer.initPDFViewer();
    });
}


function loadEmbeddedPdf(documentId, base64String) {

}


function loadPdfDocument(documentId, base64String) {
    const pdfData = documentId ? `/${appLocation}document/${documentId}` : {data: convertDataURIToBinary(base64String)}
    // const pdfViewer = new PdfViewer({pdfData, selector: "#pdf-viewport"});
    // pdfViewer.initPDFViewer();
}

async function signDocument(authenticatedPersonId, documentId, uiId) {
    $('#sigtypeselector').hide();

    const signDocumentButton = $('#signDocumentButton');
    const signatureInfo = $("#signature-info");
    signDocumentButton.hide();
    $('#collapseSignature').collapse('toggle');
    const loadingSpinner = $("#signatureContainerIFrame-" + documentId + "-loader");
    const frameSelector = "signatureContainerIFrame-" + documentId;
    const iFrame = $("#" + frameSelector);
    loadingSpinner.show();
    window.stompClient.on(`/user/queue/updated-entity/${documentId}`, (payload, message, topic) => {
        const {body, entity, errorCode, localizedMessage, id} = payload;
        if (entity === "Document") {
            iFrame.hide();
            $("#signature-info-row").hide();
            signDocumentButton.show();
            signDocumentButton.attr("disabled", true)
            finishStep(2)
            actionSuccess();
            $('#' + uiId).html('Dokument wurde erfolgreich signiert.');
            $('#somethingToDelete').val('no');
            $('#resultURL').html('<a onclick=\'finishStep(3);\' href=\'/' + appLocation + 'document/' + id + '\' target=\'_blank\'>Signiertes Dokument ansehen</a>');
            stompClient.unsubscribe(topic)
        } else if (errorCode) {
            iFrame.hide();
            signatureInfo.html(`<span style='color:red'>${localizedMessage}</span>`)
        } else {
            signatureInfo.html(body)
        }
    });
    $("#signature-info-row").show();
    signatureInfo.html("Starte Signaturanfrage...")
    const data = {
        documentId: documentId, url: window.location.origin, target: frameSelector,
    }
    const sigTypeSelectorValue = $("#sigtypeselector").val();
    if (sigTypeSelectorValue) data["sig-type"] = sigTypeSelectorValue;
    // "AMTSSIGNATURBLOCK_EN_SMALL",

    //Call the server to decrypt and duplicate the document and get the url from the file
    const soapResponse = await $.ajax({
        url: '/' + appLocation + 'pdfasproxy', context: document.body, type: 'post', data,
    });
    const result = soapResponse.result;
    iFrame.attr("src", result.redirectUrl);
    loadingSpinner.hide();
    iFrame.show();
}


//helper function to show user the current steps helping him to sign a document
function finishStep(step) {
    $('#step' + step).addClass('success');
    $('#step' + step + ' .icon').show();

    if (step === 3) {
        $('#finishButton').removeAttr('disabled');
    }
}

// creates a new document for the patient, when the doctor did send a information to the
// patient and the patient wants to store it in his documents
// sets attachment.storedInOwnDocuments true
function saveAttachment(messageId, documentId) {
    $.ajax({
        url: '/' + appLocation + 'saveAttachment',
        context: document.body,
        type: 'post',
        data: {messageId: messageId, documentId: documentId},
    })
        .done(function () {
            actionSuccess();
            $('#saveAttachmentButton' + documentId).attr('disabled', 'disabled');
            $('#saveAttachmentButton' + documentId).addClass('btn-success');
            $('#saveAttachmentButton' + documentId).html('<span class="glyphicon glyphicon-ok-circle" aria-hidden="true"></span>\n' + 'In meinen Dokumenten gespeichert');
        })
        .fail(function () {
            actionFail('Es ist ein Fehler aufgetreten! Bitte versuchen Sie es nochmal. Sollte der Fehler erneut auftreten, wenden Sie sich bitte an den Administrator.');
        });
}

function createNewDocument(patientId) {
    if (!patientId) {
        patientId = '0';
    }
    $('#DocumentsModalReplace').load('/' + appLocation + 'getDocumentsModal/0/' + patientId, function () {
        //try to preselect document createdFor with patientId
        $('select#patientId').val(patientId);
        if ($('select#patientId').val() == null) $('select#patientId').val(null); //if no receiver was found, reset it to null to show selected "Allgemein"

        $('#DocumentsModal').modal({backdrop: 'static', keyboard: false});
        registerModalSubmitButtons(patientId);
    });
}

function createNewFinding(patientId) {
    if (!patientId) {
        patientId = '0';
    }
    $('#FindingsModalReplace').load('/' + appLocation + 'getFindingsModal/0/' + patientId, function () {
        //try to preselect document createdFor with patientId
        $('#findingPatient').val(patientId);
        if ($('#findingPatient').val() == null) $('#findingPatient').val(null); //if no receiver was found, reset it to null to show selected "Allgemein"

        $('#FindingsModal').modal({backdrop: 'static', keyboard: false});
        registerModalSubmitButtons(patientId);
    });
}

function createReversalBill(documentId, listToReload, patientId) {
    customConfirm('Rechnung Stornieren', 'Wollen Sie eine Storno-Rechnung für diese Rechnung erstellen?', function () {
        $.ajax({
            url: '/' + appLocation + 'createReversalBill',
            context: document.body,
            type: 'post',
            data: {documentId: documentId},
        })
            .done(function () {
                actionSuccess();
                if (patientId) refreshBillsForPatient(patientId); else load(listToReload);
            })
            .fail(function () {
                actionFail('Es ist ein Fehler aufgetreten! Bitte versuchen Sie es nochmal. Sollte der Fehler erneut auftreten, wenden Sie sich bitte an den Administrator.');
            });
    });
}

/* ---------------------------------- */
/* section: doctor information system */

/* ---------------------------------- */

function openUrlInNewTabAndPrint(url) {
    var theWindow = window.open(url, '_blank');
    openPopUpWindowWithBrowserPermissionCheck(theWindow);
    crossBrowserPrintWindow(theWindow);
    return true;
}

function maybePrint(checkboxId, createdDocumentUrl) {
    //check if document should be printed now
    if ($('#' + checkboxId).is(':checked') && createdDocumentUrl) {
        var theWindow = window.open(createdDocumentUrl, '_blank');
        openPopUpWindowWithBrowserPermissionCheck(theWindow);
        crossBrowserPrintWindow(theWindow);
        logDocumentPrinted(null, createdDocumentUrl, true);
        return true;
    }
    return false;
}

function printDocument(relativeDocumentUrl, removeFromPrintQueue, documentId, dashboardName) {
    var theWindow = window.open('/' + appLocation + relativeDocumentUrl, '_blank');
    openPopUpWindowWithBrowserPermissionCheck(theWindow);
    crossBrowserPrintWindow(theWindow);

    logDocumentPrinted(documentId, relativeDocumentUrl, removeFromPrintQueue)
        .done(function () {
            if (removeFromPrintQueue) loadWidgetToDashboard(dashboardName, 'printQueueWidget');
        })
        .fail(function () {
            if (removeFromPrintQueue) actionFail('Dokument konnte nicht aus Druckablage entfernt werden.');
            else actionFail();
        });
}

/**
 * logs that the document was printed (or that the print was at least started)
 * @param documentId the documentId if known directly
 * @param documentURL the documentURL to parse the documentId from
 * @param removeFromPrintQueue whether to remove the document from the queue or only log that it was printed
 * @returns the ajax request object
 */
function logDocumentPrinted(
    documentId = null,
    documentURL = null,
    removeFromPrintQueue = true
) {
    return $.ajax({
        url: '/' + appLocation + 'documentPrinted',
        context: document.body,
        type: "post",
        data: {documentId, documentURL, removeFromPrintQueue}
    })
}

function crossBrowserPrintWindow(theWindow) {
    /* not working because of x-origin !?
    printJS("/" + appLocation + relativeDocumentUrl);
    */

    var sBrowser, sUsrAg = navigator.userAgent;

    //The order matters here, and this may report false positives for unlisted browsers.
    if (sUsrAg.indexOf('Firefox') > -1) {
        sBrowser = 'Mozilla Firefox';
        //"Mozilla/5.0 (X11; Ubuntu; Linux x86_64; rv:61.0) Gecko/20100101 Firefox/61.0"

        //don't print
    } else if (sUsrAg.indexOf('Opera') > -1) {
        sBrowser = 'Opera';

        theWindow.print();
    } else if (sUsrAg.indexOf('Trident') > -1) {
        sBrowser = 'Microsoft Internet Explorer';
        //"Mozilla/5.0 (Windows NT 10.0; WOW64; Trident/7.0; .NET4.0C; .NET4.0E; Zoom 3.6.0; wbx 1.0.0; rv:11.0) like Gecko"

        theWindow.print();
    } else if (sUsrAg.indexOf('Edge') > -1) {
        sBrowser = 'Microsoft Edge';
        //"Mozilla/5.0 (Windows NT 10.0; Win64; x64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/58.0.3029.110 Safari/537.36 Edge/16.16299"

        theWindow.print();
    } else if (sUsrAg.indexOf('Chrome') > -1) {
        sBrowser = 'Google Chrome or Chromium';
        //"Mozilla/5.0 (X11; Linux x86_64) AppleWebKit/537.36 (KHTML, like Gecko) Ubuntu Chromium/66.0.3359.181 Chrome/66.0.3359.181 Safari/537.36"

        theWindow.print();
    } else if (sUsrAg.indexOf('Safari') > -1) {
        sBrowser = 'Apple Safari';
        //"Mozilla/5.0 (iPhone; CPU iPhone OS 11_4 like Mac OS X) AppleWebKit/605.1.15 (KHTML, like Gecko) Version/11.0 Mobile/15E148 Safari/604.1 980x1306"

        //don't print, printing blank even with setTimeout;
    } else {
        sBrowser = 'unknown';

        theWindow.print();
    }
}

function maybeDownload(checkboxId, createdDocumentUrl) {
    //check if document should be printed now
    if ($('#' + checkboxId).is(':checked') && createdDocumentUrl) {
        var theWindow = window.open(createdDocumentUrl, '_blank');
        openPopUpWindowWithBrowserPermissionCheck(theWindow);
        return true;
    }
    return false;
}

/**
 * create Prescriptions
 * */

//load and show the modal to create
function updatePrescription(prescriptionId) {
    if (!prescriptionId) {
        prescriptionId = -1;
    }

    $('#DrugsModalReplace').load('/' + appLocation + 'getPrescriptionUpdateModal/' + prescriptionId, function () {
        $('#DrugsModal').modal({backdrop: 'static', keyboard: false});

        //Submit new Drug in Modal
        initializeDrugForm(function () {
            //not available here
        }, function (response) {
            // response.result = helper class CreatedDocumentResponse
            // document was created with signature block --> sign it
            if (response.result.withSignaturePlaceholder) {
                loadDocumentToSign(response.result.documentId, //Callback what should be done when document is signed (finish button clicked)
                    function () {
                        customConfirm('Erfolg', 'Das Dokument wurde erfolgreich signiert. Möchten Sie es jetzt versenden?', //confirm
                            function () {
                                // load documents to get necessary new created data (glyphicon and correct link)
                                loadPatientView(response.result.patientId, 'PatientViewDocuments', null, null, function () {
                                    router.navigate(appLocation + 'SendDocument/' + response.result.documentId + '/' + response.result.documentName + '/' + response.result.createdAt + '/' + response.result.patientId, {trigger: true});
                                });
                            }, //cancel
                            function () {
                                maybePrint('printPrescriptionNow', response.result.createdDocumentUrl);
                                refreshDocumentsForPatient(patientId);
                            });
                    }, //callback when user canceled action
                    function () {
                        maybePrint('printPrescriptionNow', response.result.createdDocumentUrl);
                        refreshDocumentsForPatient(patientId);
                    });
            } else {
                maybePrint('printPrescriptionNow', response.result.createdDocumentUrl);
                refreshDocumentsForPatient(patientId);
            }
        });
    });
}

function initMultiPrescription(drugId, pznId) {
    //set selected pznId and select row
    $('#pznId' + drugId).val(pznId);
    if (pznId) {
        var tableRow = $('.pznTable tr[id^=' + pznId + ']');
        tableRow.addClass('info');

        var maxOP = $('.maxOP', tableRow).html();
        $('.indTexts').hide();
        $('#ind' + pznId).show();
        $('#maxOPInfo' + pznId).html(maxOP);

        /** get EKO Comparision for PZN */
        if (pznId) {
            $('#pznInfoDiv' + drugId).load('/' + appLocation + 'getPznInfoById', {
                drugId: pznId, pznId: pznId,
            }, function () {
                $('#pznInfoDiv' + pznId).show();
                $('#DrugsModal').modal('handleUpdate');
            });
        }
    }
}

//groupName need to be specific to e.g  #patientViewPHREntries .medicalaids or #genericQuestionnaireInput .medicalaids cause if a jspanel is open it will interfere which would be confusing
function createMultiAdjuvantPrescription(patientId, tableId, genericDocumentTypeId, medicalAidRequirementId, therapyRequirementId, patientFullName, patientAvatarURL, documentTypeDescription) {
    var medicalAidSelections = $(tableId + ' .medicalaids').find('select,textarea, input').serializeArray();
    var therapySelections = $(tableId + ' .therapies').find('select,textarea, input').serializeArray();

    if ((medicalAidSelections && medicalAidSelections.length > 0) || (therapySelections && therapySelections.length > 0)) {
        var phrPreSelections = [];

        if (medicalAidSelections && medicalAidRequirementId) {
            var medicalAidIds = [];
            for (medicalAidSelection of medicalAidSelections) {
                medicalAidIds.push(medicalAidSelection['value']);
            }
            phrPreSelections.push({"requirementId": medicalAidRequirementId, "entryIds": medicalAidIds});
        }

        if (therapySelections && therapyRequirementId) {
            var therapyIds = [];
            for (therapySelection of therapySelections) {
                therapyIds.push(therapySelection['value']);
            }
            phrPreSelections.push({"requirementId": therapyRequirementId, "entryIds": therapyIds});
        }

        saveGenericDocument(patientId, null, genericDocumentTypeId, false, patientFullName, patientAvatarURL, documentTypeDescription, phrPreSelections)
    } else {
        alert('Keine Therapie, Heilbehelf oder Hilfsmittel ausgewählt. Markieren Sie durch Klicken auf die Zeile die gewünschten Therapien, Heilbehelfe oder Hilfsmittel.');
    }
}

function createPatientRecordSummary(patientId, tableId, genericDocumentTypeId, patientRecordRequirementId, patientFullName, patientAvatarURL, documentTypeDescription) {
    var selections = $(tableId).find('table tbody tr input:checked');
    if (selections && selections.length < 1) {
        selections = $(tableId).find('table tbody tr input');
    }

    if (selections && selections.length > 0) {
        var phrPreSelections = [];

        var phrEntryIds = [];
        for (selection of selections) {
            phrEntryIds.push(selection['value']);
        }
        phrPreSelections.push({"requirementId": patientRecordRequirementId, "entryIds": phrEntryIds});

        saveGenericDocument(patientId, null, genericDocumentTypeId, false, patientFullName, patientAvatarURL, documentTypeDescription, phrPreSelections)
    } else {
        alert('Keine Protokoll-Einträge vorhanden.');
    }
}

function createGenericDocumentForDrugs(patientId, tableId, genericDocumentTypeId, drugRequirementId, patientFullName, patientAvatarURL, documentTypeDescription) {
    var drugSelections = $(tableId + ' #DrugsTableForDoctor').find('select,textarea, input').serializeArray();

    if (drugSelections && drugSelections.length < 1) {
        drugSelections = $(tableId + ' #DrugsTableForDoctor').find('tbody tr input');
    }

    if (drugSelections && drugSelections.length > 0) {
        var phrPreSelections = [];

        var drugIds = [];
        for (drugSelection of drugSelections) {
            drugIds.push(drugSelection['value']);
        }
        phrPreSelections.push({"requirementId": drugRequirementId, "entryIds": drugIds});

        saveGenericDocument(patientId, null, genericDocumentTypeId, false, patientFullName, patientAvatarURL, documentTypeDescription, phrPreSelections)
    } else {
        alert('Keine aktiven Medikamente vorhanden.');
    }
}

function createPrescription(drugId, patientId, input, mpProcessUUID = null) {
    var drugIds = [];
    drugIds.push(drugId);

    getPrescriptionModal(drugIds, patientId, undefined, undefined, input, mpProcessUUID);
}


function createMultiDrugPrescription(patientId, tableId, requirementId, input, mpProcessUUID = null) {
    var drugDataTable = $('#' + tableId).DataTable();

    var drugs = drugDataTable.rows('.selected').data();
    var drugIds = [];

    if (drugs.count() == 0) {
        alert('Keine Medikamente ausgewählt. Markieren Sie durch Klicken auf die Zeile die gewünschten Medikamente.');
    } else {
        drugs.each(function (drug) {
            drugIds.push($(drug[0]).val());
        });
        getPrescriptionModal(drugIds, patientId, tableId, requirementId, input, mpProcessUUID);
    }
}

function getPrescriptionModal(drugIds, patientId, tableId, requirementId, input, mpProcessUUID = null) {
    const query = {};
    if (mpProcessUUID) query.mpProcessUUID = mpProcessUUID;
    var queryString = $.param(query);
    if (queryString) queryString = "?" + queryString;

    $('#DrugsModalReplace').load(`/${appLocation}getPrescriptionModal/${patientId}/${drugIds}${queryString}`, function () {
        $('#DrugsModal').modal({backdrop: 'static', keyboard: false});

        //Submit new Drug in Modal
        initializeDrugForm(function () {
            //not available here
        }, function (response) {
            // response.result = helper class CreatedDocumentResponse
            // document was created with signature block --> sign it
            if (response.result.withSignaturePlaceholder) {
                loadDocumentToSign(response.result.documentId, //Callback what should be done when document is signed (finish button clicked)
                    function () {
                        customConfirm('Erfolg', 'Das Dokument wurde erfolgreich signiert. Möchten Sie es jetzt versenden?', //confirm
                            function () {
                                // load documents to get necessary new created data (glyphicon and correct link)
                                loadById('Documents', response.result.patientId, function () {
                                    router.navigate(appLocation + 'SendDocument/' + response.result.documentId + '/' + response.result.documentName + '/' + response.result.createdAt + '/' + response.result.patientId, {trigger: true});
                                });
                            }, //cancel
                            function () {
                                maybePrint('printPrescriptionNow', response.result.createdDocumentUrl);
                                refreshDocumentsForPatient(patientId);
                            });
                    }, //callback when user canceled action
                    function () {
                        maybePrint('printPrescriptionNow', response.result.createdDocumentUrl);
                        refreshDocumentsForPatient(patientId);
                    });
            } else {
                maybePrint('printPrescriptionNow', response.result.createdDocumentUrl);
                refreshDrugsForPatient(patientId, tableId, input, requirementId);
            }
        });
    });
}

//load and show the modal to create
function saveBillTemplate(billTemplateId) {
    if (!billTemplateId) {
        billTemplateId = -1;
    }

    $('#BillTemplateModalReplace').load('/' + appLocation + 'getBillTemplateModal/' + billTemplateId, function () {
        $('#BillTemplateModal').modal({backdrop: 'static', keyboard: false});
        registerBillTemplateModalSubmitButton();
    });
}

//what happens when user clicks on create
function registerBillTemplateModalSubmitButton() {
    $('#billTemplateForm').submit(function (e) {
        //prevent double submitting
        var submitButtonId = 'billTemplateFormSubmitButton';
        var oldButtonText = setButtonInWaitingMode(submitButtonId);
        //remove old error messages after resubmit
        $('.error-msg').remove();
        $('#error-msg-billTemplate-form').hide();

        $.ajax({
            url: $(this).attr('action'), context: document.body, type: 'post', data: $(this).serialize(),
        })
            .done(function (response) {
                $('#error-msg-billTemplate-form').show('fast');
                showAjaxResponse(response, 'billTemplate', 'BillTemplateModal');

                if (response.status == 'SUCCESS') {
                    $('#BillTemplateModal').modal('hide');
                    $('#BillTemplateModalReplace').html('');
                    reloadCurrentContent();
                } else {
                    wakeButtonFromWaitingMode(submitButtonId, oldButtonText);
                }
            })
            .fail(function (error) {
                $('#error-msg-billTemplate-form').show('fast');
                showAjaxError(error, 'billTemplate');
                wakeButtonFromWaitingMode(submitButtonId, oldButtonText);
            });
        return false;
    });
}

//what happens when user clicks on create
function registerBillModalSubmitButton(patientId) {
    $('#billForm').submit(function (e) {
        //prevent double submitting
        var submitButtonId = 'billFormSubmitButton';
        var oldButtonText = setButtonInWaitingMode(submitButtonId);

        //remove old error messages after resubmit
        $('.error-msg').remove();
        $('#error-msg-bill-form').hide();

        $.ajax({
            url: $(this).attr('action'), context: document.body, type: 'post', data: $(this).serialize(),
        })
            .done(function (response) {
                $('#error-msg-bill-form').show('fast');
                showAjaxResponse(response, 'bill'); //, 'BillModal');
                // if the document was successfully created, show the modal to sign the document
                // (only if it should be signed) or reload documents to view or print the created document
                if (response.status == 'SUCCESS') {
                    var panelId = patientId + 'Bill';
                    loadUnbilledItemsList(patientId);
                    refreshBillsForPatient(patientId);
                    // response.result = helper class CreatedDocumentResponse
                    // document was created with signature block --> sign it
                    if (response.result.withSignaturePlaceholder) {
                        loadDocumentToSign(response.result.documentId, //Callback what should be done when document is signed (finish button clicked)
                            function () {
                                customConfirm('Erfolg', 'Das Dokument wurde erfolgreich signiert. Möchten Sie es jetzt versenden?', //confirm
                                    function () {
                                        // load documents to get necessary new created data (glyphicon and correct link)
                                        loadById('Documents', response.result.patientId, function () {
                                            router.navigate(appLocation + 'SendDocument/' + response.result.documentId + '/' + response.result.documentName + '/' + response.result.createdAt + '/' + response.result.patientId, {trigger: true});
                                        });
                                        maybePrint('printBillNow', response.result.createdDocumentUrl);
                                        maybeDownload('printReceiptNow', response.result.externalPDFUrl);
                                    }, //cancel
                                    function () {
                                        refreshBillsForPatient(patientId);
                                        maybePrint('printBillNow', response.result.createdDocumentUrl);
                                        maybeDownload('printReceiptNow', response.result.externalPDFUrl);
                                    });
                            }, //callback when user canceled action
                            function () {
                                refreshBillsForPatient(patientId);
                                maybePrint('printBillNow', response.result.createdDocumentUrl);
                                maybeDownload('printReceiptNow', response.result.externalPDFUrl);
                            });
                    }
                    // document will not get signed digital --> show documents list to print it or whatever
                    else {
                        // refreshBillsForPatient(patientId);
                        maybePrint('printBillNow', response.result.createdDocumentUrl);
                        maybeDownload('printReceiptNow', response.result.externalPDFUrl);
                    }
                    jsPanels[panelId].close();
                    // $('#BillModal').modal("hide");
                } else {
                    wakeButtonFromWaitingMode(submitButtonId, oldButtonText);
                }
            })
            .fail(function (error) {
                $('#error-msg-bill-form').show('fast');
                showAjaxError(error, 'bill');
                wakeButtonFromWaitingMode(submitButtonId, oldButtonText);
            });
        return false;
    });
}

//what happens when user clicks on create
function registerBillModalPaymentStateOnlySubmitButton(billId) {
    $('#billFormPaymentStateOnly').submit(function (e) {
        //prevent double submitting
        var submitButtonId = 'billFormPaymentStateOnlySubmitButton';
        var oldButtonText = setButtonInWaitingMode(submitButtonId);

        //remove old error messages after resubmit
        $('.error-msg').remove();
        $('#error-msg-bill-form').hide();

        $.ajax({
            url: $(this).attr('action'), context: document.body, type: 'post', data: $(this).serialize(),
        })
            .done(function (response) {
                $('#error-msg-bill-form').show('fast');
                showAjaxResponse(response, 'bill'); //, 'BillModal');
                // if the document was successfully created, show the modal to sign the document
                // (only if it should be signed) or reload documents to view or print the created document
                if (response.status == 'SUCCESS') {
                    var panelId = billId + 'Bill';
                    filterBills();
                    jsPanels[panelId].close();
                    if (response.result?.openDocumentView)
                        window.open('/' + appLocation + 'PatientViewDocuments/' + response.result.patientId, "_blank").focus();
                } else {
                    wakeButtonFromWaitingMode(submitButtonId, oldButtonText);
                }
            })
            .fail(function (error) {
                $('#error-msg-bill-form').show('fast');
                showAjaxError(error, 'bill');
                wakeButtonFromWaitingMode(submitButtonId, oldButtonText);
            });
        return false;
    });
}

//load and show the modal to create
function saveCollectiveBill(accountId, collectiveBillId) {
    if (!accountId) {
        accountId = -1;
    }
    if (!collectiveBillId) {
        collectiveBillId = -1;
    }

    $('#CollectiveBillModalReplace').load('/' + appLocation + 'getCollectiveBillModal/' + accountId + '/' + collectiveBillId, function () {
        setComboBoxValue('collectiveBillSubject', accountId);
        $('#CollectiveBillModal').modal({backdrop: 'static', keyboard: false});
        registerCollectiveBillModalSubmitButton(accountId);
    });
}

//what happens when user clicks on create
function registerCollectiveBillModalSubmitButton(patientId) {
    $('#collectiveBillForm').submit(function (e) {
        //prevent double submitting
        var submitButtonId = 'collectiveBillFormSubmitButton';
        var oldButtonText = setButtonInWaitingMode(submitButtonId);

        //remove old error messages after resubmit
        $('.error-msg').remove();
        $('#error-msg-collectiveBill-form').hide();

        $.ajax({
            url: $(this).attr('action'), context: document.body, type: 'post', data: $(this).serialize(),
        })
            .done(function (response) {
                $('#error-msg-collectiveBill-form').show('fast');
                showAjaxResponse(response, 'collectiveBill', 'CollectiveBillModal');

                // if the document was successfully created, show the modal to sign the document
                // (only if it should be signed) or reload documents to view or print the created document
                if (response.status == 'SUCCESS') {
                    $('#CollectiveBillModal').modal('hide');
                    refreshDocumentsForPatient(patientId);

                    // response.result = helper class CreatedDocumentResponse
                    // document was created with signature block --> sign it
                    if (response.result.withSignaturePlaceholder) {
                        loadDocumentToSign(response.result.documentId, //Callback what should be done when document is signed (finish button clicked)
                            function () {
                                customConfirm('Erfolg', 'Das Dokument wurde erfolgreich signiert. Möchten Sie es jetzt versenden?', //confirm
                                    function () {
                                        // load documents to get necessary new created data (glyphicon and correct link)
                                        loadById('Documents', response.result.patientId, function () {
                                            router.navigate(appLocation + 'SendDocument/' + response.result.documentId + '/' + response.result.documentName + '/' + response.result.createdAt + '/' + response.result.patientId, {trigger: true});
                                        });
                                        maybePrint('printCollectiveBillNow', response.result.createdDocumentUrl);
                                        maybeDownload('printReceiptNow', response.result.externalPDFUrl);
                                    }, //cancel
                                    function () {
                                        loadById('CollectiveBills', patientId);
                                        maybePrint('printCollectiveBillNow', response.result.createdDocumentUrl);
                                        maybeDownload('printReceiptNow', response.result.externalPDFUrl);
                                    });
                            }, //callback when user canceled action
                            function () {
                                loadById('CollectiveBills', patientId);
                                maybePrint('printCollectiveBillNow', response.result.createdDocumentUrl);
                                maybeDownload('printReceiptNow', response.result.externalPDFUrl);
                            });
                    }
                    // document will not get signed digital --> show documents list to print it or whatever
                    else {
                        loadById('CollectiveBills', patientId);
                        maybePrint('printCollectiveBillNow', response.result.createdDocumentUrl);
                        maybeDownload('printReceiptNow', response.result.externalPDFUrl);
                    }
                } else {
                    wakeButtonFromWaitingMode(submitButtonId, oldButtonText);
                }
            })
            .fail(function (error) {
                $('#error-msg-collectiveBill-form').show('fast');
                showAjaxError(error, 'collectiveBill');
                wakeButtonFromWaitingMode(submitButtonId, oldButtonText);
            });
        return false;
    });
}

function addReimbursementItem(comboBoxId, billUseDateForBillItems) {
    var selectElement = $('#' + comboBoxId)[0];
    var option = selectElement.options[selectElement.selectedIndex];
    var items = JSON.parse(option.getAttribute('items'));
    for (const item of items) {
        var nextItemStat = Number($('#nextItemStat').val());
        $('#nextItemStat').val(nextItemStat + 1);
        appendBillItem(nextItemStat, item['id'], item['code'], item['description'], item['price'], billUseDateForBillItems, false, undefined, undefined, item['vat']);
    }
    $('#' + selectElement.id)
        .val(null)
        .trigger('change');
}

/*START OF APPENDING REIMBURSEMENT ITEMS*/

function appendBillItem(nextItemStat, reimbursementItemId, reimbursementItemCode, reimbursementItemDescription, reimbursementItemPrice, showDate, autofocus) {
    appendBillItem(nextItemStat, reimbursementItemId, reimbursementItemCode, reimbursementItemDescription, reimbursementItemPrice, showDate, autofocus, undefined, undefined, undefined, undefined);
}

//append an reimbursementItem to the reimbursementItem list (div id=reimbursementItems)
function appendBillItem(nextItemStat, reimbursementItemId, reimbursementItemCode, reimbursementItemDescription, reimbursementItemPrice, showDate, autofocus, reimbursementItemDate, reimbursementItemQuantity, reimbursementItemVat, unbilledItemId) {
    var billItemId = nextItemStat;
    reimbursementItemId = reimbursementItemId ? reimbursementItemId : '';
    reimbursementItemCode = reimbursementItemCode ? reimbursementItemCode : '';
    reimbursementItemDescription = reimbursementItemDescription ? reimbursementItemDescription : '';
    reimbursementItemPrice = reimbursementItemPrice ? reimbursementItemPrice : '';
    reimbursementItemDate = reimbursementItemDate ? reimbursementItemDate : '';
    reimbursementItemQuantity = reimbursementItemQuantity ? reimbursementItemQuantity : '1';
    reimbursementItemVat = reimbursementItemVat ? reimbursementItemVat : '';
    unbilledItemId = unbilledItemId ? unbilledItemId : -1;
    /**
     * the added bill item should only autofocus, when a custom bill item was added, not when a reimbursement item was added.
     */
    var autofocusAttribute = autofocus ? 'autofocus=\'autofocus\'' : '';

    var item = '<div class="form-group" id="appendedBillItem' + billItemId + '">\n' + '                            <input style="display: none;" value="-1" type="text" class="form-control" name="itemIds"/>\n' + '                            <input style="display: none;" value="' + reimbursementItemId + '" type="text" class="form-control" name="itemReimbursementItemIds"/>\n' + '                            <input style="display: none;" value="' + unbilledItemId + '" type="text" class="form-control" name="itemUnbilledItemIds"/>\n';
    if (showDate) {
        item += '                            <div class="col-sm-2 col-xs-12">\n' + '                                <div class="input-group date datetimepicker-item' + billItemId + '-date"\n' + '                                     id="datetimepicker-item' + billItemId + '-date">\n' + '                                    <input type="text" class="form-control" name="itemDates" value="' + reimbursementItemDate + '"/>\n' + '                                    <span class="input-group-addon"><span class="glyphicon glyphicon-calendar"></span></span>\n' + '                                </div>\n' + '                                <div id="error-msg-item' + billItemId + '-date"></div>\n' + '                            </div>\n';
    }
    item += '                            <div class="col-sm-1 col-xs-12">\n' + '                                <div>\n' + '                                    <input type=\'text\' class="form-control" pattern="[-]*[0-9]+([\\.,][0-9]+)?" title="Zahl mit max. 2 Dezimalstellen" onchange="this.value = this.value.replace(/,/g, \'.\')" name="itemQuantities" value="' + reimbursementItemQuantity + '"/>\n' + '                                </div>\n' + '                                <div id="\'error-msg-item' + billItemId + '-quantity\'"></div>\n' + '                            </div>\n' + '                            <div class="col-sm-1 col-xs-12">\n' + '                                <div>\n' + '                                    <input type=\'text\' class="form-control" name="itemCodes" value="' + reimbursementItemCode + '"/>\n' + '                                </div>\n' + '                                <div id="\'error-msg-item' + billItemId + '-code\'"></div>\n' + '                            </div>\n' + '                            <div class="col-sm-4 col-xs-12">\n' + '                                <div>\n' + '                                    <input type=\'text\'' + autofocusAttribute + ' class="form-control billItemDescriptionInputField" name="itemDescriptions" value="' + reimbursementItemDescription + '"/>\n' + '                                </div>\n' + '                                <div id="\'error-msg-item' + billItemId + '-description\'"></div>\n' + '                            </div>\n' + '                            <div class="col-sm-2 col-xs-12 totalAmountOnlyHideSection">\n' + '                                <div>\n' + '                                    <input type=\'text\' class="form-control" pattern="[-]*[0-9]+([\\.,][0-9]+)?" title="Zahl mit max. 2 Dezimalstellen" onchange="this.value = this.value.replace(/,/g, \'.\')" name="itemPrices" value="' + reimbursementItemPrice + '"/>\n' + '                                </div>\n' + '                                <div id="\'error-msg-item' + billItemId + '-price\'"></div>\n' + '                            </div>\n' + '                            <div class="col-sm-1 col-xs-12 totalAmountOnlyHideSection">\n' + '                                <div>\n' + '                                    <input type=\'text\' class="form-control" name="itemVATS" value="' + reimbursementItemVat + '"/>\n' + '                                </div>\n' + '                                <div id="\'error-msg-item' + billItemId + '-vat\'"></div>\n' + '                            </div>\n' + '                            <div class="col-sm-1 col-xs-12">' + '                               <button type="button" class="btn btn-link" onclick="removeBillItem(' + billItemId + ');">' + '                                   <span style="color:dimgrey;" class="glyphicon glyphicon-remove"></span>' + '                               </button>' + '                                   <input style="display: none;" name="itemDeletes" value="false"/>' + '                            </div>\n' + '                        </div>';

    $('#billItems').append(item);
    if (showDate) {
        $('.datetimepicker-item' + billItemId + '-date').datetimepicker({
            format: 'DD.MM.YYYY', showTodayButton: true, showClose: true, locale: 'de', defaultDate: new Date(),
        });

        try {
            updateStartAndEndDateOfBill($('.datetimepicker-item' + billItemId + '-date')
                .data('DateTimePicker')
                .date());
        } catch (e) {
            console.log(e);
        }

        $('.datetimepicker-item' + billItemId + '-date').on('dp.change', function (e) {
            updateStartAndEndDateOfBill(e.date);
        });
    }
    initializeBillItemDescriptions(billItemId);

    showHideTotalAmountOnlySections();

    if ($('#BillTemplateModal')) {
        $('#BillTemplateModal').find('[autofocus]').focus();
        $('#BillTemplateModal').modal('handleUpdate');
    }
    if ($('#BillModal')) {
        $('#BillModal').find('[autofocus]').focus();
    }

    $('.billItemDescriptionInputField').keypress(function (e) {
        if (e.which == 13) {
            //when user clicks enter
            addBillItem(showDate);
            return false;
        }
    });
}

function showHideTotalAmountOnlySections() {
    if ($('#printAmountSettingCustomBillingAmount').prop('checked')) {
        $('.totalAmountOnlyShowSection').show();
        $('.totalAmountOnlyHideSection').hide();
    } else {
        $('.totalAmountOnlyShowSection').hide();
        $('.totalAmountOnlyHideSection').show();
    }
}

function removeBillItem(billItemToRemoveId) {
    $('#appendedBillItem' + billItemToRemoveId).remove();
}

function addBillItem(showDate) {
    //append it to html container
    var nextItemStat = Number($('#nextItemStat').val());
    $('#nextItemStat').val(nextItemStat + 1);

    appendBillItem(nextItemStat, undefined, undefined, undefined, undefined, showDate, true);
}

function initializeBillItemDescriptions(theClass) {
    var customBillItemDescriptions = new Bloodhound({
        datumTokenizer: Bloodhound.tokenizers.obj.whitespace('name'),
        queryTokenizer: Bloodhound.tokenizers.whitespace,
        limit: 100,

        prefetch: {
            url: '/' + appLocation + 'getCustomBillItemDescriptions', filter: function (list) {
                return $.map(list, function (entry) {
                    return {name: entry};
                });
            }, ttl: 10000,
        },
    });

    // kicks off the loading/processing of `local` and `prefetch`
    customBillItemDescriptions.initialize();

    $('.prefetch-customBillItemDescriptions' + theClass + ' .typeahead').typeahead({
        hint: true, highlight: true, minLength: 3,
    }, {
        name: 'customBillItemDescriptions', display: 'name', source: customBillItemDescriptions.ttAdapter(),
    });
}

function updateStartAndEndDateOfBill(itemDate) {
    var billStartDate = $('.datetimepicker-billStartDate')
        .data('DateTimePicker')
        .date();
    var billEndDate = $('.datetimepicker-billEndDate')
        .data('DateTimePicker')
        .date();
    if (itemDate > billEndDate) {
        $('.datetimepicker-billEndDate').data('DateTimePicker').date(itemDate);
    }
    if (itemDate < billStartDate) {
        $('.datetimepicker-billStartDate').data('DateTimePicker').date(itemDate);
    }
}

/*UNBILLED ITEMS*/

function setUnbilledItemAttribute(itemStat, attribute, value, successCallback) {
    var divId = 'unbilledItem' + itemStat + '-' + attribute;
    var errorDivId = '#error-msg-' + divId;
    var unbilledItemId = getUnbilledItemIdFromStat(itemStat);

    if ($(errorDivId).text()) {
        $(errorDivId).html('');
    }

    $.ajax({
        url: '/' + appLocation + 'setUnbilledItemAttribute', context: document.body, type: 'post', data: {
            unbilledItemId: unbilledItemId, attribute: attribute, value: value,
        },
    })
        .done(function () {
            actionSuccess();
            if (typeof successCallback === 'function') successCallback();
        })
        .fail(function (e) {
            if (e && e.responseText) {
                if ($(errorDivId)) {
                    actionFail();
                    showResponseEntityMessage(divId, e.responseText);
                } else {
                    actionFail(e.responseText);
                }
            } else {
                actionFail();
            }
        });
}

function duplicateUnbilledItem(itemStat, patientContextId) {
    var unbilledItemId = getUnbilledItemIdFromStat(itemStat);
    showLoaderIn('.UnbilledItemsListBlock');
    $.ajax({
        url: '/' + appLocation + 'duplicateUnbilledItemsList',
        context: document.body,
        type: 'post',
        data: {id: unbilledItemId},
    })
        .done(function () {
            actionSuccess();
            loadUnbilledItemsList(patientContextId);
        })
        .fail(function () {
            actionFail('Der Eintrag konnte nicht dupliziert werden.');
        });
}

function deleteUnbilledItem(itemStat, currentPatientContextId) {
    var unbilledItemId = getUnbilledItemIdFromStat(itemStat);
    deleteById('UnbilledItemsList', unbilledItemId, null, currentPatientContextId);
}

function loadUnbilledItemsList(currentPatientContextId) {
    if (currentPatientContextId == undefined) {
        currentPatientContextId = -1;
    }
    reload('UnbilledItemsList', currentPatientContextId, function () {
        updateUnbilledItemBadge();
    }, null, null, null);
}

function updateUnbilledItemBadge() {
    var count = $('#unbilledItems-count').val();
    if (!count) {
        count = '0';
    }
    var badge = $('#unbilledItemBadge');
    badge.text(count);
    if (count == '0') {
        badge.addClass('successBadge');
        badge.removeClass('messageBadge');
    } else {
        badge.addClass('messageBadge');
        badge.removeClass('successBadge');
    }
    badge.removeClass('hidden');
}

function getUnbilledItemIdFromStat(itemStat) {
    return $('#unbilledItem' + itemStat + '-id').val();
}

function getNextUnbilledItemStat() {
    var statElement = $('#unbilledItems-nextItemStat');
    var stat = Number(statElement.val());
    statElement.val(stat + 1);
    return stat;
}

function newBillForUnbilledItems(currentPatientContextId, patientFullName, useDateForBillItems, usePriceForBillItems, useVatForBillItems) {
    saveBill(currentPatientContextId, undefined, patientFullName, function () {
        var minDate;
        var maxDate;
        var count = parseInt($('#unbilledItems-count').val());
        for (var i = 0; i < count; i++) {
            var nextItemStat = Number($('#nextItemStat').val());
            $('#nextItemStat').val(nextItemStat + 1);
            var unbilledItemId = $('#unbilledItem' + i + '-id').val();
            var selected = $('#unbilledItem' + i + '-selected').prop('checked');
            if (!selected) {
                continue;
            }
            var reimbursementItemId = $('#unbilledItem' + i + '-reimbursementItemId').val();
            var date = useDateForBillItems ? $('#unbilledItem' + i + '-date input').val() : '';
            var code = $('#unbilledItem' + i + '-code').val();
            var quantity = $('#unbilledItem' + i + '-quantity').val();
            var description = $('#unbilledItem' + i + '-description').val();
            var price = usePriceForBillItems ? $('#unbilledItem' + i + '-price').val() : '';
            var vat = useVatForBillItems ? $('#unbilledItem' + i + '-vat').val() : '';
            appendBillItem(nextItemStat, reimbursementItemId, code, description, price, useDateForBillItems, false, date, quantity, vat, unbilledItemId);
            // Note that updateStartAndEndDateOfBill doesn't work here because start and end are pre-filled with current day
            // and it is likely that the unbilledItems are of an earlier date. So, EndDate would not be updated.
            var curDate = $('.datetimepicker-item' + nextItemStat + '-date')
                .data('DateTimePicker')
                .date();
            if (minDate == undefined || curDate < minDate) {
                minDate = curDate;
            }
            if (maxDate == undefined || curDate > maxDate) {
                maxDate = curDate;
            }
        }
        // At this time, the DateTimePickers may not yet have been initialized, so we have to wait.
        setTimeout(function () {
            $('.datetimepicker-billStartDate').data('DateTimePicker').date(minDate);
            $('.datetimepicker-billEndDate').data('DateTimePicker').date(maxDate);
        }, 1000);
    });
}

/* NewUnbilledItems Dialog */

function showNewUnbilledItemsDialog(tab) {
    openDialog('UnbilledItem', null, true); // don't close the dialog.
    var currentTab = null;
    var currentTabElement = $('#newUnbilledItemsTabList li.active a')[0];
    // if no tab is active, then default to the first one. this could be "all" or "private" (depending on data.reimbursementItems)
    if (!currentTabElement) {
        currentTabElement = $('#newUnbilledItemsTabList li a')[0];
    }
    currentTab = currentTabElement.href.split('-')[1];
    var tabExists = $('#newUnbilledItemsTabList a[href="#newUnbilledItemsTab-' + tab + '"]')[0] != undefined;
    if (!tab || !tabExists) {
        tab = currentTab;
    }
    // need timeout to allow for rendering to finish
    window.setTimeout(function () {
        var elem = $('#newUnbilledItemsTabList a[href="#newUnbilledItemsTab-' + tab + '"]');
        elem.tab('show');
        if (tab == currentTab) {
            elem.trigger('shown.bs.tab');
        }
    }, 100);
}

function showTabInPatientViewModule(tabListId, tabId) {
    // need timeout to allow for rendering to finish
    window.setTimeout(function () {
        var elem = $('#' + tabListId + ' a[href="#' + tabId + '"]');
        elem.tab('show');
        /* if (tabId == currentTab) {
             elem.trigger('shown.bs.tab');
         }*/
    }, 1000);
}

function addToNewUnbilledItemsButtonClick(id, code, description) {
    var row = '    <tr id="selectedUnbilledItem-' + id + '" data-id="' + id + '">' + '        <td style="display: none"></td>' + '        <td> <span>' + code + '</span></td>' + '        <td><span>' + description + '</span></td>' + '        <td style="text-align:right;">' + '            <button onclick="removeFromNewUnbilledItemsButtonClick(' + id + ');"' + '                    title="Entfernen" class="btn btn-default btn-xs" type="button">' + '                <span style="color:dimgray" class="glyphicon glyphicon-remove"></span>' + '            </button>' + '        </td>' + '    </tr>';
    $('#selectedNewUnbilledItemsTableBody').append(row);
    updateSaveNewUnbilledItemsButtonState();
}

function removeFromNewUnbilledItemsButtonClick(id) {
    $('#selectedUnbilledItem-' + id).remove();
    updateSaveNewUnbilledItemsButtonState();
}

function clearSelectedNewUnbilledItems() {
    $('[id^=selectedUnbilledItem-]').remove();
    updateSaveNewUnbilledItemsButtonState();
}

function updateSaveNewUnbilledItemsButtonState() {
    var ids = getSelectedNewUnbilledItemIds();
    $('#saveNewUnbilledItemsButton').prop('disabled', ids.length == 0);
}

function getSelectedNewUnbilledItemIds() {
    var rows = $('[id^=selectedUnbilledItem-]');
    return rows
        .map(function () {
            return $(this).data('id');
        })
        .get();
}

function saveNewUnbilledItemsClick(patientId) {
    var ids = getSelectedNewUnbilledItemIds();
    saveNewUnbilledItems(patientId, ids);
    if ($('#chevronForOptionalFieldsUnbilledItemsArea').hasClass('glyphicon-chevron-down')) {
        toggleOptionalFields('UnbilledItemsArea', 'Offene Leistungen', 'Offene Leistungen', null);
    }
    instantCloseDialogs();
}

function saveNewUnbilledItems(patientId, ids) {
    if (!patientId || patientId == 'null' || patientId == 'undefined') {
        patientId = $('#currentPatientContextId').val();
    }
    $.ajax({
        url: '/' + appLocation + 'addNewUnbilledItems?patientId=' + patientId,
        context: document.body,
        type: 'post',
        contentType: 'application/json; charset=utf-8',
        data: JSON.stringify(ids),
    })
        .done(function () {
            actionSuccess();
            clearSelectedNewUnbilledItems();
            loadUnbilledItemsList(patientId);
        })
        .fail(function () {
            actionFail('Die ausgewählten Leistungen konnten nicht erfasst werden.');
        });
}

function addItemToGroup(reimbursementItemId, reimbursementItemGroupId) {
    var url = '/' + appLocation + 'addItemToGroup?reimbursementItemId=' + reimbursementItemId;
    if (reimbursementItemGroupId) {
        url += '&reimbursementItemGroupId=' + reimbursementItemGroupId;
    }
    $.ajax({
        url: url, context: document.body, type: 'post',
    })
        .done(function () {
            actionSuccess();
        })
        .fail(function () {
            actionFail('Die Leistung konnte nicht zum Leistungsblock hinzugefügt werden.');
        });
}

function addItemToAppointmentType(reimbursementItemId, appointmentTypeId) {
    var url = '/' + appLocation + 'addItemToAppointmentType?reimbursementItemId=' + reimbursementItemId;
    if (appointmentTypeId) {
        url += '&appointmentTypeId=' + appointmentTypeId;
    }
    $.ajax({
        url: url, context: document.body, type: 'post',
    })
        .done(function () {
            actionSuccess();
        })
        .fail(function () {
            actionFail('Die Leistung konnte nicht mit der Terminart verknüpft werden.');
        });
}

function removeItemFromAppointmentType(appointmentTypeReimbursementItemId) {
    customConfirm(
        "Bitte bestätigen",
        "Sind Sie sicher, dass Sie diese Leistung von der Terminart entfernen möchten?", function () {
            var url = '/' + appLocation + 'removeItemFromAppointmentType?appointmentTypeReimbursementItemId=' + appointmentTypeReimbursementItemId;

            $.ajax({
                url: url, context: document.body, type: 'post',
            })
                .done(function () {
                    actionSuccess();
                    reloadCurrentContent();
                })
                .fail(function () {
                    actionFail('Die Leistung konnte nicht von der Terminart entfernt werden.');
                });
        }
    );
}

function editGroupItem(groupItemId) {
    var panelId = 'GroupItemModal';
    var title = 'Leistungsblock';
    var pathParam = '';
    if (groupItemId) {
        panelId = groupItemId + panelId;
        pathParam = '/' + groupItemId;
    } else {
        panelId = 'New' + panelId;
        title = 'Neuer ' + title;
    }
    saveBillPanel(panelId, title, function () {
        $(this.content).load('/' + appLocation + 'getGroupItemModal' + pathParam, function () {
            registerGroupItemModalSaveButton(panelId);
        });
    });
}

function registerGroupItemModalSaveButton(panelId) {
    $('#groupItemForm').submit(function (e) {
        //prevent double submitting
        var submitButtonId = 'groupItemModalSubmitButton';
        var oldButtonText = setButtonInWaitingMode(submitButtonId);
        $.ajax({
            url: $(this).attr('action'), context: document.body, type: 'post', data: $(this).serialize(),
        })
            .done(function (response) {
                $('#error-msg-privateItem-form').show('fast');
                showAjaxResponse(response, 'groupItem');
                wakeButtonFromWaitingMode(submitButtonId, oldButtonText);
                if (response.status == 'SUCCESS') {
                    jsPanels[panelId].close();
                    actionSuccess();
                    showNewUnbilledItemsDialog(); // refresh current tab
                }
            })
            .fail(function (error) {
                showAjaxError(error, 'groupItem');
                wakeButtonFromWaitingMode(submitButtonId, oldButtonText);
            });
        return false;
    });
}

function deleteGroupItem(groupItemId) {
    customConfirm('Bitte bestätigen', 'Sind Sie sicher, dass Sie diesen Eintrag löschen möchten?', function () {
        showLoaderIn('.NewUnbilledItemsTabBlock');
        $.ajax({
            url: '/' + appLocation + 'deleteGroupItem', context: document.body, type: 'post', data: {id: groupItemId},
        })
            .done(function () {
                actionSuccess();
                showNewUnbilledItemsDialog(); // refresh current tab
            })
            .fail(function () {
                actionFail('Der Eintrag konnte nicht gelöscht werden.');
                showNewUnbilledItemsDialog(); // refresh current tab
            });
    });
}

function editPrivateItem(privateItemId) {
    var panelId = 'PrivateItemModal';
    var title = 'Privatleistung';
    var pathParam = '';
    if (privateItemId) {
        panelId = privateItemId + panelId;
        pathParam = '/' + privateItemId;
    } else {
        panelId = 'New' + panelId;
        title = 'Neue ' + title;
    }
    saveBillPanel(panelId, title, function () {
        $(this.content).load('/' + appLocation + 'getPrivateItemModal' + pathParam, function () {
            registerPrivateItemModalSaveButton(panelId);
        });
    });
}

function registerPrivateItemModalSaveButton(panelId) {
    $('#privateItemForm').submit(function (e) {
        //prevent double submitting
        var submitButtonId = 'privateItemModalSubmitButton';
        var oldButtonText = setButtonInWaitingMode(submitButtonId);
        $.ajax({
            url: $(this).attr('action'), context: document.body, type: 'post', data: $(this).serialize(),
        })
            .done(function (response) {
                $('#error-msg-privateItem-form').show('fast');
                showAjaxResponse(response, 'privateItem');
                wakeButtonFromWaitingMode(submitButtonId, oldButtonText);
                if (response.status == 'SUCCESS') {
                    jsPanels[panelId].close();
                    actionSuccess();
                    showNewUnbilledItemsDialog(); // refresh current tab
                }
            })
            .fail(function (error) {
                showAjaxError(error, 'privateItem');
                wakeButtonFromWaitingMode(submitButtonId, oldButtonText);
            });
        return false;
    });
}

function deletePrivateItem(privateItemId) {
    customConfirm('Bitte bestätigen', 'Sind Sie sicher, dass Sie diesen Eintrag löschen möchten?', function () {
        showLoaderIn('.NewUnbilledItemsTabBlock');
        $.ajax({
            url: '/' + appLocation + 'deletePrivateItem',
            context: document.body,
            type: 'post',
            data: {id: privateItemId},
        })
            .done(function () {
                actionSuccess();
                showNewUnbilledItemsDialog(); // refresh current tab
            })
            .fail(function () {
                actionFail('Der Eintrag konnte nicht gelöscht werden.');
                showNewUnbilledItemsDialog(); // refresh current tab
            });
    });
}

function addFavourite(reimbursementItemId) {
    var url = '/' + appLocation + 'addFavourite?reimbursementItemId=' + reimbursementItemId;
    $.ajax({
        url: url, context: document.body, type: 'post',
    })
        .done(function () {
            actionSuccess();
            updateFavouritesButtonBar();
        })
        .fail(function () {
            actionFail('Die Leistung konnte nicht zu Favoriten hinzugefügt werden.');
        });
}

function removeFavourite(favouriteReimbursementItemId) {
    var url = '/' + appLocation + 'removeFavourite?favouriteReimbursementItemId=' + favouriteReimbursementItemId;
    $.ajax({
        url: url, context: document.body, type: 'post',
    })
        .done(function () {
            actionSuccess();
            showNewUnbilledItemsDialog(); // refresh current tab
            updateFavouritesButtonBar();
        })
        .fail(function () {
            actionFail('Favorit konnte nicht entfernt werden.');
        });
}

function moveFavouriteUp(favouriteReimbursementItemId) {
    var url = '/' + appLocation + 'moveFavouriteUp?favouriteReimbursementItemId=' + favouriteReimbursementItemId;
    $.ajax({
        url: url, context: document.body, type: 'post',
    })
        .done(function () {
            actionSuccess();
            showNewUnbilledItemsDialog(); // refresh current tab
            updateFavouritesButtonBar();
        })
        .fail(function () {
            actionFail('Favorit konnte nicht vorgereiht werden.');
        });
}

function updateFavouritesButtonBar() {
    var selector = '#unbilledItemsFavourites';
    var currentPatientContextId = $('#currentPatientContextId').val();
    if (currentPatientContextId) {
        showLoaderIn(selector);
        var url = '/' + appLocation + 'getFavouritesButtonBar?currentPatientContextId=' + currentPatientContextId;
        $(selector).load(url);
    }
}

/*START OF APPENDING COLLECTIVE BILL ITEMS*/

//append an reimbursementItem to the reimbursementItem list (div id=reimbursementItems)
function appendCollectiveBillItem(nextItemStat) {
    var collectiveBillItemId = nextItemStat;

    $('#collectiveBillItems').append('<div class="form-group" id="appendedCollectiveBillItem' + collectiveBillItemId + '">\n' + '                            <input style="display: none;" value="-1" type="text" class="form-control" name="itemIds"/>\n' + '                            <div class="col-sm-2 col-xs-12">\n' + '                                <div class="input-group date datetimepicker-item' + collectiveBillItemId + '-date"\n' + '                                     id="datetimepicker-item' + collectiveBillItemId + '-date">\n' + '                                    <input type="text" class="form-control" name="itemDates"/>\n' + '                                    <span class="input-group-addon"><span class="glyphicon glyphicon-calendar"></span></span>\n' + '                                </div>\n' + '                                <div id="error-msg-item' + collectiveBillItemId + '-date"></div>\n' + '                            </div>\n' + '                            <div class="col-sm-1 col-xs-12">\n' + '                                <div>\n' + '                                    <input type=\'text\' class="form-control" name="itemCodes"/>\n' + '                                </div>\n' + '                                <div id="\'error-msg-item' + collectiveBillItemId + '-code\'"></div>\n' + '                            </div>\n' + '                            <div class="col-sm-3 col-xs-12">\n' + '                                <div>\n' + '                                    <input type=\'text\' class="form-control" name="itemDescriptions"/>\n' + '                                </div>\n' + '                                <div id="\'error-msg-item' + collectiveBillItemId + '-description\'"></div>\n' + '                            </div>\n' + '                            <div class="col-sm-4 col-xs-12">\n' + '                                <div class="prefetch-customBillItemReasons' + collectiveBillItemId + '">\n' + '                                    <input type=\'text\' class="form-control typeahead" name="itemReasons"/>\n' + '                                </div>\n' + '                                <div id="\'error-msg-item' + collectiveBillItemId + '-reason\'"></div>\n' + '                            </div>\n' + '                            <div class="col-sm-1 col-xs-12">\n' + '                                <div>\n' + '                                    <input type=\'text\' onchange="this.value = this.value.replace(/,/g, \'.\')" pattern="[-]*[0-9]+([\\.,][0-9]+)?" title="Zahl mit max. 2 Dezimalstellen" class="form-control" name="itemValues"/>\n' + '                                </div>\n' + '                                <div id="\'error-msg-item' + collectiveBillItemId + '-value\'"></div>\n' + '                            </div>\n' + '                            <div class="col-sm-1 col-xs-12">' + '                               <button type="button" class="btn btn-link" onclick="removeCollectiveBillItem(' + collectiveBillItemId + ');">' + '                                   <span style="color:dimgrey;" class="glyphicon glyphicon-remove"></span>' + '                               </button>' + '                                   <input style="display: none;" name="itemDeletes" value="false"/>' + '                            </div>\n' + '                        </div>');

    $('.datetimepicker-item' + collectiveBillItemId + '-date').datetimepicker({
        format: 'DD.MM.YYYY', showTodayButton: true, showClose: true, locale: 'de', defaultDate: new Date(),
    });

    initializeCollectiveBillItemReasons(collectiveBillItemId);

    $('#CollectiveBillModal').modal('handleUpdate');
}

function removeCollectiveBillItem(collectiveBillItemToRemoveId) {
    $('#appendedCollectiveBillItem' + collectiveBillItemToRemoveId).remove();
}

function addCollectiveBillItem() {
    //append it to html container
    var nextItemStat = Number($('#nextItemStat').val());
    $('#nextItemStat').val(nextItemStat + 1);

    appendCollectiveBillItem(nextItemStat);
}

function initializeCollectiveBillItemReasons(theClass) {
    var customBillItemReasons = new Bloodhound({
        datumTokenizer: Bloodhound.tokenizers.obj.whitespace('name'),
        queryTokenizer: Bloodhound.tokenizers.whitespace,
        limit: 100,

        prefetch: {
            url: '/' + appLocation + 'getCustomBillItemReason', filter: function (list) {
                return $.map(list, function (entry) {
                    return {name: entry};
                });
            }, ttl: 10000,
        },
    });

    // kicks off the loading/processing of `local` and `prefetch`
    customBillItemReasons.initialize();

    $('.prefetch-customBillItemReasons' + theClass + ' .typeahead').typeahead({
        hint: true, highlight: true, minLength: 3,
    }, {
        name: 'customBillItemReasons', display: 'name', source: customBillItemReasons.ttAdapter(),
    });
}

//load and show the modal to create
function createNewVisitConfirmation(patientId) {
    if (!patientId) {
        patientId = -1;
    }
    $('#NewVisitConfirmationModalReplace').load('/' + appLocation + 'getNewVisitConfirmationModal/' + patientId, function () {
        setComboBoxValue('visitConfirmationPatient', patientId);
        $('#NewVisitConfirmationModal').modal({
            backdrop: 'static', keyboard: false,
        });
        registerNewVisitConfirmationModalSubmitButton(patientId);
    });
}

//what happens when user clicks on create
function registerNewVisitConfirmationModalSubmitButton(patientId) {
    $('#newVisitConfirmationForm').submit(function (e) {
        //prevent double submitting
        var submitButtonId = 'visitConfirmationSubmitButton';
        var oldButtonText = setButtonInWaitingMode(submitButtonId);

        //remove old error messages after resubmit
        $('.error-msg').remove();
        $('#error-msg-newVisitConfirmation-form').hide();

        $.ajax({
            url: $(this).attr('action'), context: document.body, type: 'post', data: $(this).serialize(),
        })
            .done(function (response) {
                $('#error-msg-newVisitConfirmation-form').show('fast');
                showAjaxResponse(response, 'newVisitConfirmation', 'NewVisitConfirmationModal');

                // if the document was successfully created, show the modal to sign the document
                // (only if it should be signed) or reload documents to view or print the created document
                if (response.status == 'SUCCESS') {
                    $('#NewVisitConfirmationModal').modal('hide');
                    refreshDocumentsForPatient(patientId);

                    // response.result = helper class CreatedDocumentResponse
                    // document was created with signature block --> sign it
                    if (response.result.withSignaturePlaceholder) {
                        loadDocumentToSign(response.result.documentId, //Callback what should be done when document is signed (finish button clicked)
                            function () {
                                customConfirm('Erfolg', 'Das Dokument wurde erfolgreich signiert. Möchten Sie es jetzt versenden?', //confirm
                                    function () {
                                        // load documents to get necessary new created data (glyphicon and correct link)
                                        loadById('Documents', response.result.patientId, function () {
                                            router.navigate(appLocation + 'SendDocument/' + response.result.documentId + '/' + response.result.documentName + '/' + response.result.createdAt + '/' + response.result.patientId, {trigger: true});
                                        });
                                        maybePrint('printVisitConfirmationNow', response.result.createdDocumentUrl);
                                    }, //cancel
                                    function () {
                                        refreshDocumentsForPatient(patientId);
                                        maybePrint('printVisitConfirmationNow', response.result.createdDocumentUrl);
                                    });
                            }, //callback when user canceled action
                            function () {
                                refreshDocumentsForPatient(patientId);
                                maybePrint('printVisitConfirmationNow', response.result.createdDocumentUrl);
                            });
                    }
                    // document will not get signed digital --> show documents list to print it or whatever
                    else {
                        refreshDocumentsForPatient(patientId);
                        maybePrint('printVisitConfirmationNow', response.result.createdDocumentUrl);
                    }
                } else {
                    wakeButtonFromWaitingMode(submitButtonId, oldButtonText);
                }
            })
            .fail(function (error) {
                $('#error-msg-newVisitConfirmation-form').show('fast');
                showAjaxError(error, 'newVisitConfirmation');
                wakeButtonFromWaitingMode(submitButtonId, oldButtonText);
            });
        return false;
    });
}

//load and show the modal to create
function createNewDueDateForBabyConfirmation(patientId) {
    if (!patientId) {
        patientId = -1;
    }
    $('#NewDueDateForBabyConfirmationModalReplace').load('/' + appLocation + 'getNewDueDateForBabyConfirmationModal/' + patientId, function () {
        setComboBoxValue('dueDateForBabyConfirmationPatient', patientId);
        $('#NewDueDateForBabyConfirmationModal').modal({
            backdrop: 'static', keyboard: false,
        });
        registerNewDueDateForBabyConfirmationModalSubmitButton(patientId);
    });
}

//what happens when user clicks on create
function registerNewDueDateForBabyConfirmationModalSubmitButton(patientId) {
    $('#newDueDateForBabyConfirmationForm').submit(function (e) {
        //prevent double submitting
        var submitButtonId = 'dueDateForBabyConfirmationSubmitButton';
        var oldButtonText = setButtonInWaitingMode(submitButtonId);

        //remove old error messages after resubmit
        $('.error-msg').remove();
        $('#error-msg-newDueDateForBabyConfirmation-form').hide();

        $.ajax({
            url: $(this).attr('action'), context: document.body, type: 'post', data: $(this).serialize(),
        })
            .done(function (response) {
                $('#error-msg-newDueDateForBabyConfirmation-form').show('fast');
                showAjaxResponse(response, 'newDueDateForBabyConfirmation', 'NewDueDateForBabyConfirmationModal');

                // if the document was successfully created, show the modal to sign the document
                // (only if it should be signed) or reload documents to view or print the created document
                if (response.status == 'SUCCESS') {
                    $('#NewDueDateForBabyConfirmationModal').modal('hide');
                    refreshDocumentsForPatient(patientId);

                    // response.result = helper class CreatedDocumentResponse
                    // document was created with signature block --> sign it
                    if (response.result.withSignaturePlaceholder) {
                        loadDocumentToSign(response.result.documentId, //Callback what should be done when document is signed (finish button clicked)
                            function () {
                                customConfirm('Erfolg', 'Das Dokument wurde erfolgreich signiert. Möchten Sie es jetzt versenden?', //confirm
                                    function () {
                                        // load documents to get necessary new created data (glyphicon and correct link)
                                        loadById('Documents', response.result.patientId, function () {
                                            router.navigate(appLocation + 'SendDocument/' + response.result.documentId + '/' + response.result.documentName + '/' + response.result.createdAt + '/' + response.result.patientId, {trigger: true});
                                        });
                                        maybePrint('printDueDateForBabyConfirmationNow', response.result.createdDocumentUrl);
                                    }, //cancel
                                    function () {
                                        refreshDocumentsForPatient(patientId);
                                        maybePrint('printDueDateForBabyConfirmationNow', response.result.createdDocumentUrl);
                                    });
                            }, //callback when user canceled action
                            function () {
                                refreshDocumentsForPatient(patientId);
                                maybePrint('printDueDateForBabyConfirmationNow', response.result.createdDocumentUrl);
                            });
                    }
                    // document will not get signed digital --> show documents list to print it or whatever
                    else {
                        refreshDocumentsForPatient(patientId);
                        maybePrint('printDueDateForBabyConfirmationNow', response.result.createdDocumentUrl);
                    }
                } else {
                    wakeButtonFromWaitingMode(submitButtonId, oldButtonText);
                }
            })
            .fail(function (error) {
                $('#error-msg-newDueDateForBabyConfirmation-form').show('fast');
                showAjaxError(error, 'newDueDateForBabyConfirmation');
                wakeButtonFromWaitingMode(submitButtonId, oldButtonText);
            });
        return false;
    });
}

//load and show the modal to create
function saveFindingsReport(patientId, findingsReportId) {
    if (!findingsReportId) {
        findingsReportId = -1;
    }
    if (!patientId) {
        patientId = -1;
    }
    $('#FindingsReportModalReplace').load('/' + appLocation + 'getFindingsReportModal/' + patientId + '/' + findingsReportId, function () {
        setComboBoxValue('findingsReportPatient', patientId);
        $('#FindingsReportModal').modal({backdrop: 'static', keyboard: false});
        registerFindingsReportModalSubmitButton(patientId);
    });
}

//what happens when user clicks on create
function registerFindingsReportModalSubmitButton(patientId) {
    $('#findingsReportForm').submit(function (e) {
        //prevent double submitting
        var submitButtonId = 'findingsReportSubmitButton';
        var oldButtonText = setButtonInWaitingMode(submitButtonId);

        //remove old error messages after resubmit
        $('.error-msg').remove();
        $('#error-msg-findingsReport-form').hide();

        $.ajax({
            url: $(this).attr('action'), context: document.body, type: 'post', data: $(this).serialize(),
        })
            .done(function (response) {
                $('#error-msg-findingsReport-form').show('fast');
                showAjaxResponse(response, 'findingsReport', 'FindingsReportModal');

                // if the document was successfully created, show the modal to sign the document
                // (only if it should be signed) or reload documents to view or print the created document
                if (response.status == 'SUCCESS') {
                    $('#FindingsReportModal').modal('hide');
                    refreshDocumentsForPatient(patientId);

                    // response.result = helper class CreatedDocumentResponse
                    // document was created with signature block --> sign it
                    if (response.result.withSignaturePlaceholder) {
                        loadDocumentToSign(response.result.documentId, //Callback what should be done when document is signed (finish button clicked)
                            function () {
                                customConfirm('Erfolg', 'Das Dokument wurde erfolgreich signiert. Möchten Sie es jetzt versenden?', //confirm
                                    function () {
                                        // load documents to get necessary new created data (glyphicon and correct link)
                                        loadById('Documents', response.result.patientId, function () {
                                            router.navigate(appLocation + 'SendDocument/' + response.result.documentId + '/' + response.result.documentName + '/' + response.result.createdAt + '/' + response.result.patientId, {trigger: true});
                                        });
                                        maybePrint('printFindingsReportNow', response.result.createdDocumentUrl);
                                    }, //cancel
                                    function () {
                                        refreshDocumentsForPatient(patientId);
                                        maybePrint('printFindingsReportNow', response.result.createdDocumentUrl);
                                    });
                            }, //callback when user canceled action
                            function () {
                                refreshDocumentsForPatient(patientId);
                                maybePrint('printFindingsReportNow', response.result.createdDocumentUrl);
                            });
                    }
                    // document will not get signed digital --> show documents list to print it or whatever
                    else {
                        refreshDocumentsForPatient(patientId);
                        maybePrint('printFindingsReportNow', response.result.createdDocumentUrl);
                    }
                } else {
                    wakeButtonFromWaitingMode(submitButtonId, oldButtonText);
                }
            })
            .fail(function (error) {
                $('#error-msg-findingsReport-form').show('fast');

                showAjaxError(error, 'findingsReport');
                wakeButtonFromWaitingMode(submitButtonId, oldButtonText);
            });
        return false;
    });
}

//load and show the modal to create
function saveInsulinPlan(patientId, insulinPlanId) {
    if (!insulinPlanId) {
        insulinPlanId = -1;
    }
    if (!patientId) {
        patientId = -1;
    }
    $('#InsulinPlanModalReplace').load('/' + appLocation + 'getInsulinPlanModal/' + patientId + '/' + insulinPlanId, function () {
        setComboBoxValue('insulinPlanPatient', patientId);
        /*$("#InsulinPlanModal").modal({backdrop: 'static', keyboard: false});*/
        $('#InsulinPlanModal').modal({backdrop: 'static', keyboard: false});
        registerInsulinPlanModalSubmitButton(patientId);
    });
}

//what happens when user clicks on create
function registerInsulinPlanModalSubmitButton(patientId) {
    $('#insulinPlanForm').submit(function (e) {
        //prevent double submitting
        var submitButtonId = 'insulinPlanSubmitButton';
        var oldButtonText = setButtonInWaitingMode(submitButtonId);

        //remove old error messages after resubmit
        $('.error-msg').remove();
        $('#error-msg-insulinPlan-form').hide();

        $.ajax({
            url: $(this).attr('action'), context: document.body, type: 'post', data: $(this).serialize(),
        })
            .done(function (response) {
                $('#error-msg-insulinPlan-form').show('fast');
                showAjaxResponse(response, 'insulinPlan', 'InsulinPlanModal');

                // if the document was successfully created, show the modal to sign the document
                // (only if it should be signed) or reload documents to view or print the created document
                if (response.status == 'SUCCESS') {
                    $('#InsulinPlanModal').modal('hide');
                    refreshDocumentsForPatient(patientId);

                    // response.result = helper class CreatedDocumentResponse
                    // document was created with signature block --> sign it
                    if (response.result.withSignaturePlaceholder) {
                        loadDocumentToSign(response.result.documentId, //Callback what should be done when document is signed (finish button clicked)
                            function () {
                                customConfirm('Erfolg', 'Das Dokument wurde erfolgreich signiert. Möchten Sie es jetzt versenden?', //confirm
                                    function () {
                                        // load documents to get necessary new created data (glyphicon and correct link)
                                        loadById('Documents', response.result.patientId, function () {
                                            router.navigate(appLocation + 'SendDocument/' + response.result.documentId + '/' + response.result.documentName + '/' + response.result.createdAt + '/' + response.result.patientId, {trigger: true});
                                        });
                                        maybePrint('printInsulinPlanNow', response.result.createdDocumentUrl);
                                    }, //cancel
                                    function () {
                                        refreshDocumentsForPatient(patientId);
                                        maybePrint('printInsulinPlanNow', response.result.createdDocumentUrl);
                                    });
                            }, //callback when user canceled action
                            function () {
                                refreshDocumentsForPatient(patientId);
                                maybePrint('printInsulinPlanNow', response.result.createdDocumentUrl);
                            });
                    }
                    // document will not get signed digital --> show documents list to print it or whatever
                    else {
                        refreshDocumentsForPatient(patientId);
                        maybePrint('printInsulinPlanNow', response.result.createdDocumentUrl);
                    }
                } else {
                    wakeButtonFromWaitingMode(submitButtonId, oldButtonText);
                }
            })
            .fail(function (error) {
                $('#error-msg-insulinPlan-form').show('fast');
                showAjaxError(error, 'insulinPlan');
                wakeButtonFromWaitingMode(submitButtonId, oldButtonText);
            });
        return false;
    });
}

//load and show the modal to create
function saveCTReferral(patientId, ctReferralId) {
    if (!ctReferralId) {
        ctReferralId = -1;
    }
    if (!patientId) {
        patientId = -1;
    }
    $('#CTReferralModalReplace').load('/' + appLocation + 'getCTReferralModal/' + patientId + '/' + ctReferralId, function () {
        setComboBoxValue('ctReferralPatient', patientId);
        /*$("#CTReferralModal").modal({backdrop: 'static', keyboard: false});*/
        $('#CTReferralModal').modal({backdrop: 'static', keyboard: false});
        registerCTReferralModalSubmitButton(patientId);
    });
}

//what happens when user clicks on create
function registerCTReferralModalSubmitButton(patientId) {
    $('#ctReferralForm').submit(function (e) {
        //prevent double submitting
        var submitButtonId = 'ctReferralSubmitButton';
        var oldButtonText = setButtonInWaitingMode(submitButtonId);

        //remove old error messages after resubmit
        $('.error-msg').remove();
        $('#error-msg-ctReferral-form').hide();

        $.ajax({
            url: $(this).attr('action'), context: document.body, type: 'post', data: $(this).serialize(),
        })
            .done(function (response) {
                $('#error-msg-ctReferral-form').show('fast');
                showAjaxResponse(response, 'ctReferral', 'CTReferralModal');
                // if the document was successfully created, show the modal to sign the document
                // (only if it should be signed) or reload documents to view or print the created document
                if (response.status == 'SUCCESS') {
                    $('#CTReferralModal').modal('hide');
                    refreshDocumentsForPatient(patientId);
                    // response.result = helper class CreatedDocumentResponse
                    // document was created with signature block --> sign it
                    if (response.result.withSignaturePlaceholder) {
                        loadDocumentToSign(response.result.documentId, //Callback what should be done when document is signed (finish button clicked)
                            function () {
                                customConfirm('Erfolg', 'Das Dokument wurde erfolgreich signiert. Möchten Sie es jetzt versenden?', //confirm
                                    function () {
                                        // load documents to get necessary new created data (glyphicon and correct link)
                                        loadById('Documents', response.result.patientId, function () {
                                            router.navigate(appLocation + 'SendDocument/' + response.result.documentId + '/' + response.result.documentName + '/' + response.result.createdAt + '/' + response.result.patientId, {trigger: true});
                                        });
                                        maybePrint('printCTReferralNow', response.result.createdDocumentUrl);
                                    }, //cancel
                                    function () {
                                        refreshDocumentsForPatient(patientId);
                                        maybePrint('printCTReferralNow', response.result.createdDocumentUrl);
                                    });
                            }, //callback when user canceled action
                            function () {
                                refreshDocumentsForPatient(patientId);
                                maybePrint('printCTReferralNow', response.result.createdDocumentUrl);
                            });
                    }
                    // document will not get signed digital --> show documents list to print it or whatever
                    else {
                        refreshDocumentsForPatient(patientId);
                        maybePrint('printCTReferralNow', response.result.createdDocumentUrl);
                    }

                    // reset modal
                    $('#CTReferralModalReplace').html('');
                } else {
                    wakeButtonFromWaitingMode(submitButtonId, oldButtonText);
                }
            })
            .fail(function (error) {
                $('#error-msg-ctReferral-form').show('fast');
                showAjaxError(error, 'ctReferral');
                wakeButtonFromWaitingMode(submitButtonId, oldButtonText);
            });
        return false;
    });
}

//load and show the modal to create
function saveMRIReferral(patientId, mriReferralId) {
    if (!mriReferralId) {
        mriReferralId = -1;
    }
    if (!patientId) {
        patientId = -1;
    }
    $('#MRIReferralModalReplace').load('/' + appLocation + 'getMRIReferralModal/' + patientId + '/' + mriReferralId, function () {
        setComboBoxValue('mriReferralPatient', patientId);
        /*$("#MRIReferralModal").modal({backdrop: 'static', keyboard: false});*/
        $('#MRIReferralModal').modal({backdrop: 'static', keyboard: false});
        registerMRIReferralModalSubmitButton(patientId);
    });
}

//what happens when user clicks on create
function registerMRIReferralModalSubmitButton(patientId) {
    $('#mriReferralForm').submit(function (e) {
        //prevent double submitting
        var submitButtonId = 'mriReferralSubmitButton';
        var oldButtonText = setButtonInWaitingMode(submitButtonId);

        //remove old error messages after resubmit
        $('.error-msg').remove();
        $('#error-msg-mriReferral-form').hide();

        $.ajax({
            url: $(this).attr('action'), context: document.body, type: 'post', data: $(this).serialize(),
        })
            .done(function (response) {
                $('#error-msg-mriReferral-form').show('fast');
                showAjaxResponse(response, 'mriReferral', 'MRIReferralModal');

                // if the document was successfully created, show the modal to sign the document
                // (only if it should be signed) or reload documents to view or print the created document
                if (response.status == 'SUCCESS') {
                    $('#MRIReferralModal').modal('hide');
                    refreshDocumentsForPatient(patientId);

                    // response.result = helper class CreatedDocumentResponse
                    // document was created with signature block --> sign it
                    if (response.result.withSignaturePlaceholder) {
                        loadDocumentToSign(response.result.documentId, //Callback what should be done when document is signed (finish button clicked)
                            function () {
                                customConfirm('Erfolg', 'Das Dokument wurde erfolgreich signiert. Möchten Sie es jetzt versenden?', //confirm
                                    function () {
                                        // load documents to get necessary new created data (glyphicon and correct link)
                                        loadById('Documents', response.result.patientId, function () {
                                            router.navigate(appLocation + 'SendDocument/' + response.result.documentId + '/' + response.result.documentName + '/' + response.result.createdAt + '/' + response.result.patientId, {trigger: true});
                                        });
                                        maybePrint('printMRIReferralNow', response.result.createdDocumentUrl);
                                    }, //cancel
                                    function () {
                                        refreshDocumentsForPatient(patientId);
                                        maybePrint('printMRIReferralNow', response.result.createdDocumentUrl);
                                    });
                            }, //callback when user canceled action
                            function () {
                                refreshDocumentsForPatient(patientId);
                                maybePrint('printMRIReferralNow', response.result.createdDocumentUrl);
                            });
                    }
                    // document will not get signed digital --> show documents list to print it or whatever
                    else {
                        refreshDocumentsForPatient(patientId);
                        maybePrint('printMRIReferralNow', response.result.createdDocumentUrl);
                    }

                    // reset modal
                    $('#MRIReferralModalReplace').html('');
                } else {
                    wakeButtonFromWaitingMode(submitButtonId, oldButtonText);
                }
            })
            .fail(function (error) {
                $('#error-msg-mriReferral-form').show('fast');
                showAjaxError(error, 'mriReferral');
                wakeButtonFromWaitingMode(submitButtonId, oldButtonText);
            });
        return false;
    });
}

function setJSPanelResult(panel, success) {
    if (panel) {
        if (success) {
            // var headerToolbar = '<span class="navbar-text" style="display: none; color: green;">' +
            //     '<span class="glyphicon glyphicon-info-sign" style="color: white;" aria-hidden="true"></span>' +
            //     'Aktion erfolgreich' +
            //     '<span class="glyphicon glyphicon-ok" style="color: white;" aria-hidden="true"></span></span>';
            panel.setHeaderLogo('<i style="color:green;margin-left:12px" class="fa fa-check"></i>');
            setTimeout(function () {
                panel.setHeaderLogo('<span style="margin:12px"></span>');
            }, 3000);
        } else {
            panel.setHeaderLogo('<i style="color:red;margin:12px" class="fa fa-times"></i>');
        }
    }
}

function setJSPanelLoading(panel) {
    if (panel) {
        panel.setHeaderLogo('<i style="margin-left:10px" class="fa fa-spinner fa-spin"></i>');
    }
}

var jsPanels = {};

function saveBillFromTemplate(patientId, templateId, name) {
    if (!patientId) {
        patientId = -1;
    }
    var title = 'Honorarnote';
    if (name) {
        title += ' für ' + name;
    }
    var panelId = patientId + 'Bill';

    saveBillPanel(panelId, title, function () {
        $(this.content).load('/' + appLocation + 'getBillModalFromTemplate/' + patientId + '/' + templateId, function () {
            setComboBoxValue('billSubject', patientId);
            registerBillModalSubmitButton(patientId);
        });
    });
}

function saveBill(patientId, billId, name) {
    saveBill(patientId, billId, name, undefined);
}

function saveBill(patientId, billId, name, callback) {
    if (!patientId) {
        patientId = -1;
    }
    if (!billId) {
        billId = -1;
    }
    var title = 'Honorarnote';
    if (name) {
        title += ' für ' + name;
    }
    var panelId = patientId + 'Bill';

    saveBillPanel(panelId, title, function () {
        $(this.content).load('/' + appLocation + 'getBillModal/' + patientId + '/' + billId, function () {
            setComboBoxValue('billSubject', patientId);
            registerBillModalSubmitButton(patientId);
            if (callback) {
                callback();
            }
        });
    });
}

function updateBillPaymentState(billId) {
    var title = 'Zahlungsstatus Honorarnote ändern';
    var panelId = billId + 'Bill';

    saveBillPanel(panelId, title, function () {
        $(this.content).load('/' + appLocation + 'getBillModalPaymentStateOnly/' + billId, function () {
            registerBillModalPaymentStateOnlySubmitButton(billId);
        });
    });
}

let wahDaMeTransferModal;

function openWAHDaMeTransferModal(patientId, billId, confirmRepeatWah) {
    if (wahDaMeTransferModal) {
        wahDaMeTransferModal.front();
        /* mediprimeAppPanel.unsmallify();
         mediprimeAppPanel.reposition({
             my: "center",
         });*/
        return;
    } else {
        const options = {
            footerToolbar: '<span class="pull-right">WAH-Online</span>',
            headerLogo:
                '<span style="padding:10px" class="glyphicon glyphicon-phone" title="mediprime.app" aria-hidden="true"></span>',
            contentSize: {width: '70%', height: '75%'},
            onwindowresize: true,
            closeOnEscape: true,
            borderRadius: 3,

            onclosed: function (panel) {
                wahDaMeTransferModal = null;
            },
            onbeforeclose: function (panel) {
                refreshBillsForPatient(patientId)
                return true;
            },
            content: function () {
                $(this.content).load("/" + appLocation + "wahDaMeTransferModal", {
                    patientId,
                    billId,
                    confirmRepeatWah,
                });
            },
            headerTitle: "WAH Online über DaMe",
            theme: "#3cafa5",
        };

        wahDaMeTransferModal = jsPanel.create(options);

        if ($(window).width() <= 1120) {
            wahDaMeTransferModal.maximize();
        }
    }
}


function wahDownload(patientId, billId, confirmRepeatWah) {
    if (confirmRepeatWah) {
        customConfirm("Bitte bestätigen", "Diese Rechnung wurde bereits übermittelt. Möchten Sie diese erneut übermitteln?", function () {
            doWahDownload(patientId, billId);
        });
    } else {
        doWahDownload(patientId, billId);
    }
}

function doWahDownload(patientId, billId) {
    let url = "/" + appLocation + "wahDownload/" + billId;
    window.open(url, "_blank");
    setTimeout(function () {
        refreshBillsForPatient(patientId)
    }, 3000);
}

function saveBillPanel(panelId, title, contentFN) {
    if (jsPanels[panelId]) {
        jsPanels[panelId].front();
    } else {
        var options = {
            footerToolbar: '<span class="pull-right">' + title + '</span>',
            headerLogo: '<span style="margin:10px"></span>',
            contentSize: {width: '80%', height: '80%'},
            onwindowresize: true,
            borderRadius: 3,
            content: contentFN,
            closeOnEscape: true,
            onbeforeclose: function (panel) {
                $(panel)
                    .find('table')
                    .each(function (index, table) {
                        clearSelectedRowsFor($(table).attr('id'));
                    });
                delete jsPanels[panelId];
                return true;
            },
            headerTitle: title,
            theme: '#f2f2f2',
        };
        jsPanels[panelId] = jsPanel.create(options);
        if ($(window).width() <= 1120) {
            jsPanels[panelId].maximize();
        }
    }
}


//load and show the modal to create {patientId}/{genericDocumentId}/{genericDocumentTypeId}
function createNewClinicalExamination(patientId, genericDocumentId, genericDocumentTypeId, submitButtonId) {
    if (!patientId) {
        alert('not working for generic documents! patient is mandatory!');
    }
    if (!genericDocumentTypeId) {
        alert('not working for generic documents! genericDocumentType is mandatory!');
    }
    if (!genericDocumentId) {
        genericDocumentId = -1; //create new document or update?
    }

    //prevent double submitting
    const oldButtonText = setButtonInWaitingMode(submitButtonId);

    const form = $('#clinicalExaminationDiv' + genericDocumentTypeId + " form:first")[0];
    doPendingChangesCheck(null, false, function ({save}) {
        observeForm(form, false);

        $.ajax({
            url: '/' + appLocation + 'createNewClinicalExamination/' + patientId + '/' + genericDocumentId + '/' + genericDocumentTypeId,
            context: document.body,
            type: 'post'
        }).done(function (response) {
            var tabId = 'clinicalExaminationTab' + genericDocumentTypeId;
            loadPatientView(patientId, "ClinicalExaminations", currentPage, null, function () {
                showTabInPatientViewModule("clinicalExaminationTabList", tabId);
            });
            wakeButtonFromWaitingMode(submitButtonId, oldButtonText);
        }).fail(function (error) {
            actionFail(error);
            wakeButtonFromWaitingMode(submitButtonId, oldButtonText);
        });

    });

    setTimeout(() => wakeButtonFromWaitingMode(submitButtonId, oldButtonText), 3000); // failsafe, in case the user simply dismisses the popup
    return false;
}

//load and show the modal to create {patientId}/{genericDocumentId}/{genericDocumentTypeId}
function saveGenericDocument(patientId, genericDocumentId, genericDocumentTypeId, duplicate, subject, avatarUrl, docName, phrPreSelections) {
    if (duplicate === undefined) {
        duplicate = false;
    }
    if (!patientId) {
        alert('not working for generic documents! patient is mandatory!');
    }
    if (!genericDocumentId) {
        genericDocumentId = -1; //create new document or update?
    }

    if (!genericDocumentTypeId) {
        alert('not working for generic documents! genericDocumentType is mandatory!');
    }

    var title = 'Dokument';
    if (docName && subject) {
        title = docName + ' für ' + subject;
    } else if (docName && !subject) {
        title = docName;
    } else if (!docName && subject) {
        title += ' für: ' + subject;
    }

    if (jsPanels[genericDocumentTypeId]) {
        jsPanels[genericDocumentTypeId].front();
    } else {
        var options = {
            footerToolbar: '<span class="pull-right">' + title + '</span>',
            headerLogo: '<span style="margin:10px"></span>',
            contentSize: {width: '80%', height: '80%'},
            onwindowresize: true,
            closeOnEscape: true,
            borderRadius: 3,
            content: function (panel) {
                var url = '/' + appLocation + 'getGenericDocumentForm/' + patientId + '/' + genericDocumentId + '/' + genericDocumentTypeId + '/' + duplicate;

                $.ajax({
                    type: 'post',
                    context: document.body,
                    url: url,
                    data: JSON.stringify(phrPreSelections),
                    contentType: 'application/json; charset=utf-8'
                }).done(function (data) {
                    $(panel.content).html(data).promise().done(function () {
                        setComboBoxValue('genericDocumentFormPatient', patientId);
                        registerGenericDocumentFormSubmitButton(patientId, genericDocumentId, genericDocumentTypeId, panel);
                        focusFirstInput('genericQuestionnaireInput');
                    });
                });
            },
            onbeforeclose: function (panel) {
                const form = $(panel).find("form:first")[0];
                // i'd like to use the customConfirm, but since that works asynchronously it's not compatible with how the event handler is supposed to work
                if (form && formChangesPending(form) && !confirm("Sind Sie sicher, dass Sie das Fenster schließen möchten? Alle nicht gespeicherten Formulardaten gehen dabei verloren!")) {
                    // if there is a form within the panel, and it has changes, ask if the user is sure
                    // if confirm is false, then don't do the cleanup and simply return false
                    return false;
                }
                // when we dispose of the form, it should no longer be observed
                if (form) observeForm(form, false);

                $(panel)
                    .find('table')
                    .each(function (index, table) {
                        clearSelectedRowsFor($(table).attr('id'));
                    });
                delete jsPanels[genericDocumentTypeId];
                return true;
            },
            headerTitle: title,
            theme: '#f2f2f2',
        };
        jsPanels[genericDocumentTypeId] = jsPanel.create(options);
        if ($(window).width() <= 1120) {
            jsPanels[genericDocumentTypeId].maximize();
        }
    }
}

function preSelectPhrEntries(tableId, phrEntryIds) {
    if (phrEntryIds) {
        for (phrEntryId of phrEntryIds) {
            $("#" + tableId + " tbody tr#phrDataTableRow" + phrEntryId).toggleClass("selected");
            $("#" + tableId + " tbody tr#phrDataTableRow" + phrEntryId).find("input:checkbox").attr('checked', true);
        }
    }
}

function closeJSPanel(callback) {
    if (!_.isEmpty(jsPanels)) {
        customConfirm('Bestätigen', 'Achtung wenn Sie diese Seite verlassen, gehen alle nicht gespeicherten Änderungen verloren !', function () {
            _.each(jsPanels, function (panel, index) {
                panel.close();
            });
            jsPanels = {};
            if (callback) {
                callback();
            }
        });
    } else if (callback) {
        callback();
        jsPanels = {};
    }
}

function saveDraft(userID, docTypeId) {
    saveDocument(userID, docTypeId, true);
}

function saveDocument(userID, docTypeId, draft) {
    if (!querySessionType()) { // returns null if not authenticated, otherwise a String containing the class name
        customModalInfo(
            "Ihre Sitzung ist abgelaufen",
            "Die Änderungen können aus Sicherheitsgründen nicht mehr gespeichert werden. " +
            "Bitte kopieren sie den Inhalt manuell, und fügen sie ihn nach dem neu-anmelden erneut ein.");
        wakeButtonFromWaitingMode(submitButtonId, oldButtonText);
        return false;
    }

    //prevent double submitting
    var submitButtonId = 'saveButton' + docTypeId;
    var oldButtonText = setButtonInWaitingMode(submitButtonId);

    var genericDocumentId = $('#id').val();
    var update = genericDocumentId == -1 || genericDocumentId == '' ? false : true;
    var formData = serializeGenericQuestionnaireFormDataFor('genericDocumentForm' + docTypeId, update, false);
    var action = $('#genericDocumentForm' + docTypeId).attr('action');
    if (draft) {
        action += '?draft=true';
    }
    var genericDocTypeId = $('#genericDocumentTypeId').val();


    setJSPanelLoading(jsPanels[genericDocTypeId]);

    $.ajax({
        url: action, context: document.body, type: 'post', data: formData,
    })
        .done(function (response) {
            setFormHasChanges($(jsPanels[genericDocTypeId]).find("form:first")[0], false); // we saved, so no changes
            loadById('Documents', userID);
            setJSPanelResult(jsPanels[genericDocTypeId], true);
            if (response && response.result) {
                if (response.status == "SUCCESS") actionSuccess();

                $('#id').attr('value', response.result.documentId);
                $('#error-msg-genericDocument-' + docTypeId + '-form').show('fast');
                showAjaxResponse(response, 'genericDocument-' + docTypeId);
            }
            wakeButtonFromWaitingMode(submitButtonId, oldButtonText);
        })
        .fail(function (error) {
            $('#error-msg-genericDocument-' + docTypeId + '-form').show('fast');
            showAjaxError(error, 'genericDocument-' + docTypeId);
            actionFail(genericDocTypeId);
            setJSPanelResult(jsPanels[genericDocTypeId], false);
            wakeButtonFromWaitingMode(submitButtonId, oldButtonText);
        });
    return false;
}


function previewPDF(docTypeId) {
    var genericDocumentId = $('#id').val();
    var update = genericDocumentId == -1 || genericDocumentId == '' ? false : true;
    var formData = serializeGenericQuestionnaireFormDataForAsJson('genericDocumentForm' + docTypeId, update, false);

    $('#PDFPreviewModalReplace').load('/' + appLocation + 'createPDFPreview', formData, function (response) {
        $('#PDFPreviewModal').modal({backdrop: 'static', keyboard: false});
    });
}


function previewHTML(docTypeId) {
    var genericDocumentId = $('#id').val();
    var update = genericDocumentId == -1 || genericDocumentId == '' ? false : true;
    var formData = serializeGenericQuestionnaireFormDataForAsJson('genericDocumentForm' + docTypeId, update, false);
    let html = $(`#genericDocumentForm${docTypeId}-html`).val();
    // if (html) {
    //     $('#HTMLPreviewModal').show();
    // } else {
    $('#HTMLPreviewModalReplace').load('/' + appLocation + 'createHTMLPreview', formData, (response) => {
        $('#HTMLPreviewModal').modal({backdrop: 'static', keyboard: false});
    });
    // }
}

function resetDocumentHtml(docTypeId, successCallback) {

    customConfirm('Änderungen zurücksetzen', 'Sind Sie sicher? ' + 'Alle manuellen Änderungen des Dokuments werden zurückgesetzt und gehen beim Speichern verloren!', () => {
        $("#genericDocumentForm" + docTypeId + " #genericQuestionnaireInput").show();
        $("#genericDocumentForm" + docTypeId + " #genericQuestionnaireInputPreviewChanged").hide();
        $("#genericDocumentForm" + docTypeId + ` #genericDocumentForm${docTypeId}-html`).attr('value', '');
        if (typeof successCallback === 'function') successCallback();
    });
}

function sendDameMessageModal(documentId) {
    $('#DaMeSendModalReplace').load('/' + appLocation + 'sendDameMessageModal/' + documentId, function (response) {
        $('#DaMeSendModal').modal({backdrop: 'static', keyboard: false});
    });
}

function sendDaMeMessage(ctx, documentId) {
    var hmvId = $('#dameuserinfo-inputsendDaMeMessage').val();
    var postData = {
        id: documentId, receiver: hmvId,
    };

    if (hmvId == null || hmvId.length === 0) {
        $('#dameuserinfo-inputsendDaMeMessage-error').show();
        $('#dameuserinfo-inputsendDaMeMessage-error').html('Bitte wählen Sie einen Empfänger aus.');
        window.setTimeout(function () {
            $('#dameuserinfo-inputsendDaMeMessage-error').hide();
        }, 5000);
    } else {
        $.ajax({
            url: '/' + appLocation + 'dame/send-document', type: 'post', data: postData,
        })
            .done(function (response) {
                $('#DaMeSendModal').modal('hide');
                actionSuccess();
            })
            .fail(function (error) {
                $('#dameuserinfo-inputsendDaMeMessage-error').show();
                $('#dameuserinfo-inputsendDaMeMessage-error').html('Es ist ein Fehler aufgetreten!</br>Bitte versuchen Sie es nochmal. Sollte der Fehler erneut auftreten, wenden Sie sich bitte an den Administrator.');
                window.setTimeout(function () {
                    $('#dameuserinfo-inputsendDaMeMessage-error').hide();
                }, 5000);
            });
    }
}

function registerGenericDocumentFormSubmitButton(patientId, genericDocumentId, genericDocumentTypeId, panel //if panel is null / undefined > its a clinical examination
) {
    var formId = 'genericDocumentForm' + genericDocumentTypeId;
    $('#' + formId).submit(function (e) {
        //prevent double submitting
        var submitButtonId = 'genericDocumentFormSubmitButton' + genericDocumentTypeId;
        var oldButtonText = setButtonInWaitingMode(submitButtonId);
        var submitButtonId2 = 'genericDocumentFormSubmitButton2-' + genericDocumentTypeId;
        var oldButtonText2 = setButtonInWaitingMode(submitButtonId2);

        //remove old error messages after resubmit
        $('.error-msg').remove();
        $('#error-msg-genericDocument-form').hide();
        if (panel) {
            setJSPanelLoading(panel);
        } else {
            showLoaderIn(formId)
        }

        var genDocId = $('#id').val();
        if (genDocId !== '') {
            //eher unnoetig weil serialize die id eh anhängt wird nur fuer update gebraucht soweit ich das seh
            genericDocumentId = genDocId; //has been saved by saveDoc
        }
        var update = genericDocumentId == -1 ? false : true;
        var formData = serializeGenericQuestionnaireFormDataFor(formId, update, false);

        $.ajax({
            url: $(this).attr('action'), context: document.body, type: 'post', data: formData,
        })
            .done(function (response) {
                $('#error-msg-genericDocument-' + genericDocumentTypeId + 'form').show('fast');
                showAjaxResponse(response, 'genericDocument-' + genericDocumentTypeId);
                // if the document was successfully created, show the modal to sign the document
                // (only if it should be signed) or reload documents to view or print the created document
                if (panel) {
                    setJSPanelResult(panel, true);
                }

                if (response.status == 'SUCCESS') {
                    actionSuccess();
                    clearLocalDatatableStorage(formId);

                    if (panel) {
                        var failureCallback = function () {
                            refreshDocumentsForPatient(patientId);
                            maybePrint('printGenericDocumentNow', response.result.createdDocumentUrl);
                        };
                        // response.result = helper class CreatedDocumentResponse
                        // document was created with signature block --> sign it
                        if (response.result.withSignaturePlaceholder) {
                            loadDocumentToSign(response.result.documentId, //Callback what should be done when document is signed (finish button clicked)
                                function () {
                                    customConfirm('Erfolg', 'Das Dokument wurde erfolgreich signiert. Möchten Sie es jetzt versenden?', //confirm
                                        function () {
                                            // load documents to get necessary new created data (glyphicon and correct link)
                                            loadById('Documents', response.result.patientId, function () {
                                                router.navigate(appLocation + 'SendDocument/' + response.result.documentId + '/' + response.result.documentName + '/' + response.result.createdAt + '/' + response.result.patientId, {trigger: true});
                                            });
                                            maybePrint('printGenericDocumentNow', response.result.createdDocumentUrl);
                                        }, //cancel
                                        failureCallback);
                                }, //callback when user canceled action
                                failureCallback);
                        } else {
                            // document will not get signed digital --> show documents list to print it or whatever
                            refreshDocumentsForPatient(patientId);
                            maybePrint('printGenericDocumentNow', response.result.createdDocumentUrl);
                        }
                    }

                    if (panel) {
                        panel.close();
                    } else {
                        wakeButtonFromWaitingMode(submitButtonId, oldButtonText);
                        wakeButtonFromWaitingMode(submitButtonId2, oldButtonText2);
                    }
                } else {
                    wakeButtonFromWaitingMode(submitButtonId, oldButtonText);
                    wakeButtonFromWaitingMode(submitButtonId2, oldButtonText2);
                }
                if (window.location.pathname.indexOf("PatientViewClinicalExaminations") > 0) {
                    //reload newsfeed widget, to show new clinical examination result
                    refreshPatientViewNewsfeedWidgetIfExists(patientId)
                }
            })
            .fail(function (error) {
                $('#error-msg-genericDocument-' + genericDocumentTypeId + 'form').show('fast');
                showAjaxError(error, 'genericDocument-' + genericDocumentTypeId);
                wakeButtonFromWaitingMode(submitButtonId, oldButtonText);
                wakeButtonFromWaitingMode(submitButtonId2, oldButtonText2);
                setJSPanelResult(panel, false);
            });
        return false;
    });
}

//load and show the modal to create
function saveAdjuvantPrescription(patientId, adjuvantPrescriptionId) {
    if (!adjuvantPrescriptionId) {
        adjuvantPrescriptionId = -1;
    }
    if (!patientId) {
        patientId = -1;
    }
    $('#AdjuvantPrescriptionModalReplace').load('/' + appLocation + 'getAdjuvantPrescriptionModal/' + patientId + '/' + adjuvantPrescriptionId, function () {
        setComboBoxValue('adjuvantPrescriptionPatient', patientId);
        /*$("#AdjuvantPrescriptionModal").modal({backdrop: 'static', keyboard: false});*/
        $('#AdjuvantPrescriptionModal').modal({
            backdrop: 'static', keyboard: false,
        });
        registerAdjuvantPrescriptionModalSubmitButton(patientId);
    });
}

//what happens when user clicks on create
function registerAdjuvantPrescriptionModalSubmitButton(patientId) {
    $('#adjuvantPrescriptionForm').unbind('submit');
    $('#adjuvantPrescriptionForm').submit(function (e) {
        //prevent double submitting
        var submitButtonId = 'adjuvantPrescriptionSubmitButton';
        var oldButtonText = setButtonInWaitingMode(submitButtonId);

        //remove old error messages after resubmit
        $('.error-msg').remove();
        $('#error-msg-adjuvantPrescription-form').hide();

        $.ajax({
            url: $(this).attr('action'), context: document.body, type: 'post', data: $(this).serialize(),
        })
            .done(function (response) {
                $('#error-msg-adjuvantPrescription-form').show('fast');
                showAjaxResponse(response, 'adjuvantPrescription', 'AdjuvantPrescriptionModal');

                // if the document was successfully created, show the modal to sign the document
                // (only if it should be signed) or reload documents to view or print the created document
                if (response.status == 'SUCCESS') {
                    $('#AdjuvantPrescriptionModal').modal('hide');
                    refreshDocumentsForPatient(patientId);

                    // response.result = helper class CreatedDocumentResponse
                    // document was created with signature block --> sign it
                    if (response.result.withSignaturePlaceholder) {
                        loadDocumentToSign(response.result.documentId, //Callback what should be done when document is signed (finish button clicked)
                            function () {
                                customConfirm('Erfolg', 'Das Dokument wurde erfolgreich signiert. Möchten Sie es jetzt versenden?', //confirm
                                    function () {
                                        // load documents to get necessary new created data (glyphicon and correct link)
                                        loadById('Documents', response.result.patientId, function () {
                                            router.navigate(appLocation + 'SendDocument/' + response.result.documentId + '/' + response.result.documentName + '/' + response.result.createdAt + '/' + response.result.patientId, {trigger: true});
                                        });
                                        maybePrint('printAdjuvantPrescriptionNow', response.result.createdDocumentUrl);
                                    }, //cancel
                                    function () {
                                        refreshDocumentsForPatient(patientId);
                                        maybePrint('printAdjuvantPrescriptionNow', response.result.createdDocumentUrl);
                                    });
                            }, //callback when user canceled action
                            function () {
                                refreshDocumentsForPatient(patientId);
                                maybePrint('printAdjuvantPrescriptionNow', response.result.createdDocumentUrl);
                            });
                    }
                    // document will not get signed digital --> show documents list to print it or whatever
                    else {
                        refreshDocumentsForPatient(patientId);
                        maybePrint('printAdjuvantPrescriptionNow', response.result.createdDocumentUrl);
                    }
                }
                wakeButtonFromWaitingMode(submitButtonId, oldButtonText);
            })
            .fail(function (error) {
                $('#error-msg-adjuvantPrescription-form').show('fast');
                showAjaxError(error, 'adjuvantPrescription');
                wakeButtonFromWaitingMode(submitButtonId, oldButtonText);
            });
        return false;
    });
}

//load and show the modal to create
function createNewDoctorReferral(patientId, referralRequestId) {
    if (!patientId) {
        patientId = -1;
    }
    if (!referralRequestId) {
        referralRequestId = -1;
    }
    $('#NewDoctorReferralModalReplace').load('/' + appLocation + 'getNewDoctorReferralModal/' + patientId + '/' + referralRequestId, function () {
        setComboBoxValue('doctorReferralPatient', patientId);
        $('#NewDoctorReferralModal').modal({
            backdrop: 'static', keyboard: false,
        });
        registerNewDoctorReferralModalSubmitButton(patientId);
    });
}

//what happens when user clicks on create
function registerNewDoctorReferralModalSubmitButton(patientId) {
    $('#newDoctorReferralForm').submit(function (e) {
        //prevent double submitting
        var submitButtonId = 'doctorReferralSubmitButton';
        var oldButtonText = setButtonInWaitingMode(submitButtonId);

        //remove old error messages after resubmit
        $('.error-msg').remove();
        $('#error-msg-newDoctorReferral-form').hide();

        $.ajax({
            url: $(this).attr('action'), context: document.body, type: 'post', data: $(this).serialize(),
        })
            .done(function (response) {
                $('#error-msg-newDoctorReferral-form').show('fast');
                showAjaxResponse(response, 'newDoctorReferral', 'NewDoctorReferralModal');

                // if the document was successfully created, show the modal to sign the document
                // (only if it should be signed) or reload documents to view or print the created document
                if (response.status == 'SUCCESS') {
                    $('#NewDoctorReferralModal').modal('hide');
                    refreshDocumentsForPatient(patientId);

                    // response.result = helper class CreatedDocumentResponse
                    // document was created with signature block --> sign it
                    if (response.result.withSignaturePlaceholder) {
                        loadDocumentToSign(response.result.documentId, //Callback what should be done when document is signed (finish button clicked)
                            function () {
                                customConfirm('Erfolg', 'Das Dokument wurde erfolgreich signiert. Möchten Sie es jetzt versenden?', //confirm
                                    function () {
                                        // load documents to get necessary new created data (glyphicon and correct link)
                                        loadById('Documents', response.result.patientId, function () {
                                            router.navigate(appLocation + 'SendDocument/' + response.result.documentId + '/' + response.result.documentName + '/' + response.result.createdAt + '/' + response.result.patientId, {trigger: true});
                                        });
                                        maybePrint('printDoctorReferralNow', response.result.createdDocumentUrl);
                                    }, //cancel
                                    function () {
                                        refreshDocumentsForPatient(patientId);
                                        maybePrint('printDoctorReferralNow', response.result.createdDocumentUrl);
                                    });
                            }, //callback when user canceled action
                            function () {
                                refreshDocumentsForPatient(patientId);
                                maybePrint('printDoctorReferralNow', response.result.createdDocumentUrl);
                            });
                    }
                    // document will not get signed digital --> show documents list to print it or whatever
                    else {
                        refreshDocumentsForPatient(patientId);
                        maybePrint('printDoctorReferralNow', response.result.createdDocumentUrl);
                    }
                } else {
                    wakeButtonFromWaitingMode(submitButtonId, oldButtonText);
                }
            })
            .fail(function (error) {
                $('#error-msg-newDoctorReferral-form').show('fast');
                showAjaxError(error, 'newDoctorReferral');
                wakeButtonFromWaitingMode(submitButtonId, oldButtonText);
            });
        return false;
    });
}

//load and show the modal to create
function createNewHospitalReferral(patientId) {
    if (!patientId) {
        patientId = -1;
    }
    $('#NewHospitalReferralModalReplace').load('/' + appLocation + 'getNewHospitalReferralModal/' + patientId, function () {
        setComboBoxValue('hospitalReferralPatient', patientId);
        $('#NewHospitalReferralModal').modal({
            backdrop: 'static', keyboard: false,
        });
        registerNewHospitalReferralModalSubmitButton(patientId);
    });
}

//what happens when user clicks on create
function registerNewHospitalReferralModalSubmitButton(patientId) {
    $('#newHospitalReferralForm').submit(function (e) {
        //prevent double submitting
        var submitButtonId = 'hospitalReferralSubmitButton';
        var oldButtonText = setButtonInWaitingMode(submitButtonId);

        //remove old error messages after resubmit
        $('.error-msg').remove();
        $('#error-msg-newHospitalReferral-form').hide();

        $.ajax({
            url: $(this).attr('action'), context: document.body, type: 'post', data: $(this).serialize(),
        })
            .done(function (response) {
                $('#error-msg-newHospitalReferral-form').show('fast');
                showAjaxResponse(response, 'newHospitalReferral', 'NewHospitalReferralModal');

                // if the document was successfully created, show the modal to sign the document
                // (only if it should be signed) or reload documents to view or print the created document
                if (response.status == 'SUCCESS') {
                    $('#NewHospitalReferralModal').modal('hide');
                    refreshDocumentsForPatient(patientId);

                    // response.result = helper class CreatedDocumentResponse
                    // document was created with signature block --> sign it
                    if (response.result.withSignaturePlaceholder) {
                        loadDocumentToSign(response.result.documentId, //Callback what should be done when document is signed (finish button clicked)
                            function () {
                                customConfirm('Erfolg', 'Das Dokument wurde erfolgreich signiert. Möchten Sie es jetzt versenden?', //confirm
                                    function () {
                                        // load documents to get necessary new created data (glyphicon and correct link)
                                        loadById('Documents', response.result.patientId, function () {
                                            router.navigate(appLocation + 'SendDocument/' + response.result.documentId + '/' + response.result.documentName + '/' + response.result.createdAt + '/' + response.result.patientId, {trigger: true});
                                        });
                                        maybePrint('printHospitalReferralNow', response.result.createdDocumentUrl);
                                    }, //cancel
                                    function () {
                                        refreshDocumentsForPatient(patientId);
                                        maybePrint('printHospitalReferralNow', response.result.createdDocumentUrl);
                                    });
                            }, //callback when user canceled action
                            function () {
                                refreshDocumentsForPatient(patientId);
                                maybePrint('printHospitalReferralNow', response.result.createdDocumentUrl);
                            });
                    }
                    // document will not get signed digital --> show documents list to print it or whatever
                    else {
                        refreshDocumentsForPatient(patientId);
                        maybePrint('printHospitalReferralNow', response.result.createdDocumentUrl);
                    }
                } else {
                    wakeButtonFromWaitingMode(submitButtonId, oldButtonText);
                }
            })
            .fail(function (error) {
                $('#error-msg-newHospitalReferral-form').show('fast');
                showAjaxError(error, 'newHospitalReferral');
                wakeButtonFromWaitingMode(submitButtonId, oldButtonText);
            });
        return false;
    });
}

function registerNewReferralTemplateModalSubmitButton() {
    $('#newReferralTemplateForm').submit(function (e) {
        //prevent double submitting
        var submitButtonId = 'createNewReferralTemplateSubmitButton';
        var oldButtonText = setButtonInWaitingMode(submitButtonId);

        //remove old error messages after resubmit
        $('.error-msg').remove();
        $('#error-msg-newReferralTemplate-form').hide();

        $.ajax({
            url: $(this).attr('action'), context: document.body, type: 'post', data: $(this).serialize(),
        })
            .done(function (response) {
                $('#error-msg-newReferralTemplate-form').show('fast');
                showAjaxResponse(response, 'newReferralTemplate');

                if (response.status == 'SUCCESS') {
                    actionSuccess();
                    load('ReferralTemplates');
                } else {
                    wakeButtonFromWaitingMode(submitButtonId, oldButtonText);
                }
            })
            .fail(function (error) {
                $('#error-msg-newReferralTemplate-form').show('fast');
                showAjaxError(error, 'newReferral');
                wakeButtonFromWaitingMode(submitButtonId, oldButtonText);
            });
        return false;
    });
}

/* load a template and write the template-values in the fields */
function loadDataFromDoctorReferralTemplate(id) {
    $.ajax({
        url: '/' + appLocation + 'getDoctorReferralTemplate',
        context: document.body,
        type: 'post',
        data: {doctorReferralTemplateId: id},
    })
        .done(function (response) {
            //show the data in the form

            $('#referralReceiver').typeahead('val', response.result.receiver);
            $('#referralDiagnosis').typeahead('val', response.result.diagnosis);
            $('#referralRequest').typeahead('val', response.result.request);
            $('#medication').val(response.result.medication);
            $('#informationForPatient').val(response.result.informationForPatient);
            $('#informationForDoctor').val(response.result.informationForDoctor);
            $('#customKey1').val(response.result.customKey1);
            $('#customKey2').val(response.result.customKey2);
            $('#customKey3').val(response.result.customKey3);
            $('#customKey4').val(response.result.customKey4);
            $('#customKey5').val(response.result.customKey5);
            $('#customValue1').val(response.result.customValue1);
            $('#customValue2').val(response.result.customValue2);
            $('#customValue3').val(response.result.customValue3);
            $('#customValue4').val(response.result.customValue4);
            $('#customValue5').val(response.result.customValue5);
        })
        .fail(function () {
            actionFail();
        });
}

// approves the document with timestamp now and doctor logged in
function approveDocument(documentId, listToReload, currentPatientContextId) {
    customConfirm('Elektronisch Vidieren', 'Hiermit bestätigen Sie die Korrektheit dieses Dokuments und vidieren ' + 'damit das Dokument offiziell mit Ihrem Namen. \n\nSind Sie sicher?', function () {
        $.ajax({
            url: '/' + appLocation + 'approveDocument',
            context: document.body,
            type: 'post',
            data: {documentId: documentId},
        })
            .done(function () {
                actionSuccess();
                reload(listToReload, currentPatientContextId);
            })
            .fail(function () {
                actionFail('Es ist ein Fehler aufgetreten! Bitte versuchen Sie es nochmal. Sollte der Fehler erneut auftreten, wenden Sie sich bitte an den Administrator.');
            });
    });
}

// approves the document with timestamp now and doctor logged in - then load the send message form
function approveDocumentAndSendToAccount(documentId, documentName, documentCreatedAt, accountId) {
    customConfirm('Elektronisch Vidieren und versenden', 'Hiermit bestätigen Sie die Korrektheit dieses Dokuments und vidieren ' + 'damit das Dokument offiziell mit Ihrem Namen. \n\nSind Sie sicher?', function () {
        $.ajax({
            url: '/' + appLocation + 'approveDocument',
            context: document.body,
            type: 'post',
            data: {documentId: documentId},
        })
            .done(function () {
                router.navigate(appLocation + 'SendDocument/' + documentId + '/' + documentName + '/' + documentCreatedAt + '/' + accountId, {trigger: true});
            })
            .fail(function () {
                actionFail('Es ist ein Fehler aufgetreten! Bitte versuchen Sie es nochmal. Sollte der Fehler erneut auftreten, wenden Sie sich bitte an den Administrator.');
            });
    });
}

// approves the document with timestamp now and doctor logged in
function approveDocumentAndSendWithDefaultMessage(documentId) {
    customConfirm('Elektronisch Vidieren und SOFORT Versenden', 'Hiermit bestätigen Sie die Korrektheit dieses Dokuments und vidieren ' + 'damit das Dokument offiziell mit Ihrem Namen. Anschließend wird der Befund automatisch an den zuweisenden Arzt und den Patienten (sofern angegeben) gesendet.\n\nSind Sie sicher?', function () {
        $.ajax({
            url: '/' + appLocation + 'approveDocumentAndSendWithDefaultMessage',
            context: document.body,
            type: 'post',
            data: {documentId: documentId},
        })
            .done(function () {
                actionSuccess();
                load('Findings');
            })
            .fail(function () {
                actionFail('Es ist ein Fehler aufgetreten! Bitte versuchen Sie es nochmal. Sollte der Fehler erneut auftreten, wenden Sie sich bitte an den Administrator.');
            });
    });
}

// approves the document with timestamp now and doctor logged in
function sendFindingWithDefaultMessage(documentId) {
    customConfirm('Automatisch versenden', 'Der Befund wird nun automatisch an den zuweisenden Arzt und den Patienten (sofern angegeben) mit dem Standardtext versendet.\n\n Sind Sie sicher?', function () {
        $.ajax({
            url: '/' + appLocation + 'sendFindingWithDefaultMessage',
            context: document.body,
            type: 'post',
            data: {documentId: documentId},
        })
            .done(function () {
                actionSuccess();
                load('Findings');
            })
            .fail(function () {
                actionFail('Es ist ein Fehler aufgetreten! Bitte versuchen Sie es nochmal. Sollte der Fehler erneut auftreten, wenden Sie sich bitte an den Administrator.');
            });
    });
}

function toggleAuthorFieldsInputElements(formId, value) {
    if (value == 'me') {
        $('#' + formId)
            .find('#externalAuthorFormInput')
            .hide();
        $('#' + formId)
            .find('#internalAuthorFormInput')
            .hide();
    } else if (value == 'internal') {
        $('#' + formId)
            .find('#externalAuthorFormInput')
            .hide();
        $('#' + formId)
            .find('#internalAuthorFormInput')
            .show();
    } else if (value == 'external') {
        $('#' + formId)
            .find('#externalAuthorFormInput')
            .show();
        $('#' + formId)
            .find('#internalAuthorFormInput')
            .hide();
    }
}

function filterBills() {
    showLoaderIn('.BillsBlock');
    $('.BillsBlock').load('/' + appLocation + 'getFilteredBills', $('#billFilterForm').serialize());
}

function filterAndExportBillsCSV() {
    showLoaderIn('.BillsBlock');
    $('.BillsBlock').load('/' + appLocation + 'getFilteredBills', $('#billFilterForm').serialize());

    $.ajax({
        url: '/' + appLocation + 'downloadFilteredBillsCSV',
        context: document.body,
        type: 'get',
        data: $('#billFilterForm').serialize(),
    })
        .done(function (response) {
            downloadAsFile(response, 'Export_CSV_Rechnungen.csv');
        })
        .fail(function () {
            actionFail('Es ist ein Fehler aufgetreten! Bitte versuchen Sie es nochmal. Sollte der Fehler erneut auftreten wenden Sie sich bitte an den Administrator.');
        });
}

function downloadAsFile(csv, fileName) {
    var file = new File([csv], fileName, {type: 'text/csv'});
    var a = window.document.createElement('a');
    a.href = window.URL.createObjectURL(file);
    a.download = fileName;
    a.click();
}

function filterAndDownloadBillSummaryPDF() {
    showLoaderIn('.BillsBlock');
    $('.BillsBlock').load('/' + appLocation + 'getFilteredBills', $('#billFilterForm').serialize());
    window.open('/' + appLocation + 'downloadBillSummaryPDF?' + $('#billFilterForm').serialize(), '_blank');
}

// approves the document with timestamp now and doctor logged in
function toggleCollectiveBillPayed(collectiveBillId) {
    customConfirm('Zahlungsstatus ändern', 'Sie ändern den Zahlungsstatus dieser Honorarnote.\n\n Sind Sie sicher?', function () {
        $.ajax({
            url: '/' + appLocation + 'toggleCollectiveBillPayed',
            context: document.body,
            type: 'post',
            data: {collectiveBillId: collectiveBillId},
        })
            .done(function () {
                actionSuccess();
                load('CollectiveBills');
            })
            .fail(function () {
                actionFail('Es ist ein Fehler aufgetreten! Bitte versuchen Sie es nochmal. Sollte der Fehler erneut auftreten, wenden Sie sich bitte an den Administrator.');
            });
    });
}

function filterCollectiveBills() {
    showLoaderIn('.CollectiveBillsBlock');
    $('.CollectiveBillsBlock').load('/' + appLocation + 'getFilteredCollectiveBills', $('#collectiveBillFilterForm').serialize());
}

function filterNarcoticDrugs() {
    showLoaderIn('.NarcoticDrugsBlock');
    $('.NarcoticDrugsBlock').load('/' + appLocation + 'getFilteredNarcoticDrugs', $('#narcoticDrugFilterForm').serialize());
}

function addBillNumberGroup() {
    $.ajax({
        url: '/' + appLocation + 'addBillNumberGroup', context: document.body, type: 'post',
    })
        .done(function (response) {
            if (response.status == 'SUCCESS') {
                actionSuccess();
                router.navigate(appLocation + 'ReimbursementItems/' + response.result, {
                    trigger: true,
                });
            } else {
                actionFail();
            }
        })
        .fail(function () {
            actionFail();
        });
}

function deleteBillNumberGroup(billNumberGroupId) {
    $.ajax({
        url: '/' + appLocation + 'deleteBillNumberGroup',
        context: document.body,
        type: 'post',
        data: {billNumberGroupId: billNumberGroupId},
    })
        .done(function () {
            actionSuccess();
            router.navigate(appLocation + 'ReimbursementItems', {trigger: true});
        })
        .fail(function (e) {
            if (e && e.responseText) {
                actionFail(e.responseText);
            } else {
                actionFail();
            }
        });
}

/* default method to set a billNumberGroup setting */
function setBillNumberGroupSetting(billNumberGroupId, setting, value, successCallback) {
    if ($('#error-msg-billNumberGroup' + billNumberGroupId + '-' + setting).text()) {
        $('#error-msg-billNumberGroup' + billNumberGroupId + '-' + setting).html('');
    }
    $.ajax({
        url: '/' + appLocation + 'setBillNumberGroupSetting', context: document.body, type: 'post', data: {
            billNumberGroupId: billNumberGroupId, setting: setting, value: value,
        },
    })
        .done(function () {
            actionSuccess();
            if (typeof successCallback === 'function') successCallback();
        })
        .fail(function (e) {
            if (e && e.responseText) {
                if ($('#error-msg-billNumberGroup' + billNumberGroupId + '-' + setting)) {
                    actionFail();
                    showResponseEntityMessage('billNumberGroup' + billNumberGroupId + '-' + setting, e.responseText);
                } else {
                    actionFail(e.responseText);
                }
            } else {
                actionFail();
            }
        });
}

function formatAndSetBillNumberGroupIban(billNumberGroupId, jQueryElement, successCallback) {
    formatIban(jQueryElement);
    setBillNumberGroupSetting(billNumberGroupId, 'iban', jQueryElement.val(), successCallback);
}

function setButtonInWaitingMode(buttonId) {
    var oldButtonText = $('#' + buttonId).html();
    $('#' + buttonId).prop('disabled', true);
    $('#' + buttonId).html('Bitte warten ...');

    return oldButtonText;
}

function wakeButtonFromWaitingMode(buttonId, oldButtonText) {
    $('#' + buttonId).prop('disabled', false);
    $('#' + buttonId).html(oldButtonText);
}

function focusFirstInput(id) {
    try {
        var firstInput = $('#' + id)
            .find('input[type=text],textarea')
            .filter(':visible')[0];
        firstInput = $(firstInput);
        firstInput.attr('autofocus', true);
        $('html, body').animate({
            scrollTop: firstInput.offset().top - 20,
        }, 50, function () {
            setTimeout(function () {
                firstInput.focus();
            }, 20);
            firstInput.attr('autofocus', true);
            firstInput.focus();
        });
        return false;
    } catch (e) {
        //can't scroll to
    }
}

function createRadioOptionsRange(ctx, requirementId, questionId) {
    var data = $('#datalistItemsForm' + questionId)
        .serializeArray()
        .reduce(function (a, x) {
            a[x.name] = x.value;
            return a;
        }, {});
    // data.id = questionId;
    $.ajax({
        url: '/' + appLocation + 'admin/createRadioOptionsRange/' + questionId,
        context: document.body,
        type: 'post',
        data: data,
    })
        .done(function () {
            actionSuccess();
            reloadAbstractRequirementAfterUpdateForContext(ctx, requirementId);
        })
        .fail(function () {
            actionFail();
        });
}

function createRadioOptionsRangeForComplexQuestion(ctx, requirementId, questionId) {
    var data = $('#datalistItemsForm' + questionId)
        .serializeArray()
        .reduce(function (a, x) {
            a[x.name] = x.value;
            return a;
        }, {});
    // data.id = questionId;
    $.ajax({
        url: '/' + appLocation + 'admin/createRadioOptionsRangeForComplexQuestion/' + questionId,
        context: document.body,
        type: 'post',
        data: data,
    })
        .done(function () {
            actionSuccess();
            reloadAbstractRequirementAfterUpdateForContext(ctx, requirementId);
        })
        .fail(function () {
            actionFail();
        });
}

function addItem(evt, questionId) {
    if (evt == 'button' || event.key === 'Enter') {
        let inputValue = $('#datalistItemsValue' + questionId).val().trim();
        try {
            inputValue = JSON.parse(inputValue);
        } catch (ex) {
            inputValue = [inputValue]
        }
        let length = $('ul#datalistItems' + questionId + ' li').length;

        inputValue.map((value, index) => {
            $('#datalistItems' + questionId).append('<li class="list-group-item"><input class="form-control" type="text" name="optionsRange[-' + (length + index) + 'New]" value="' + value + '"/></li>');
        })
        $('#datalistItemsValue' + questionId).val('');
    }
}

/*START OF APPENDING REIMBURSEMENT ITEMS*/

//append an reimbursementItem to the reimbursementItem list (div id=reimbursementItems)
function appendFileNameInput(index, file, hasRoleDoctorOrAssistant) {
    var fileName = file.name;
    var suggestedFilename = fileName.replace(/\.[^.$]+$/, '');

    var newLineTemplate = document.getElementById('fileNameInputTemplate');
    var newLine = $(newLineTemplate.content.cloneNode(true));

    newLine.children().each(function () {
        var text = $(this)
            .html()
            .replace(/{{index}}/g, '' + index);
        text = text.replace(/{{fileName}}/g, '' + fileName);
        text = text.replace(/{{suggestedFilename}}/g, '' + suggestedFilename);
        $(this).html(text);
    });

    $(newLine)
        .find('.datetimepicker-newDocumentOriginalCreatedAt')
        .datetimepicker({
            format: 'DD.MM.YYYY HH:mm', showTodayButton: true, showClose: true, locale: 'de',
        });

    $(newLine)
        .find('#documentNames' + index)
        .keypress(function (e) {
            var chr = String.fromCharCode(e.which);
            if ('/'.indexOf(chr) == 0) {
                var errorSelector = $(this)
                    .parents('.multiuploadfileindex')
                    .find('.error-alert');
                errorSelector.empty();
                errorSelector.append('<div class="alert alert-danger alert-dismissible" role="alert"><button type="button" class="close" data-dismiss="alert" aria-label="Close"><span aria-hidden="true">&times;</span></button><strong>Achtung!</strong> Das Zeichen /  ist nicht erlaubt!</div>');
                return false;
            }
        });

    $('#fileNames').append(newLine);

    if (hasRoleDoctorOrAssistant) {
        var loadingUrl = '/' + appLocation + 'loadTextBlockSelector?field=documentNames' + index;
        $('#placeholder' + index).load(loadingUrl);
    }
}

function pdfDetails(pdfBlob) {
    return new Promise(function (done) {
        var reader = new FileReader();
        reader.onload = function () {
            var regex = /<x:xmpmeta[\w\W]*?<\/x:xmpmeta>/g;
            var matches = regex.exec(reader.result);
            var result = {
                DateTimeOriginal: new Date(),
            };
            if (matches != null && matches.length > 0) {
                parser = new DOMParser();
                xmlDoc = parser.parseFromString(matches[0], 'text/xml');
                var dateElement = xmlDoc.getElementsByTagName('xmp:CreateDate');
                if (dateElement.length > 0) {
                    result.DateTimeOriginal = moment(dateElement[0].innerHTML);
                }
            }
            done(result);
        };
        reader.readAsBinaryString(pdfBlob);
    });
}

function readExifData(inputTag) {
    var files = inputTag.files;
    for (var i = 0, f; (f = files[i]); i++) {
        extractDataFromFile(f, setDateFor);
    }
}

function extractDataFromFile(file, callback) {
    var extension = file.type;
    var name = file.name;
    if (extension === 'application/pdf') {
        pdfDetails(file).then(function (allMetaData) {
            allMetaData.name = name;
            callback(allMetaData);
        });
    } else {
        EXIF.getData(file, function () {
            var allMetaData = EXIF.getAllTags(this);
            allMetaData.name = name;
            callback(allMetaData);
        });
    }
}

function setDateFor(allMetaData) {
    var date = new Date();
    if (allMetaData.DateTimeOriginal) {
        date = moment(allMetaData.DateTimeOriginal, 'YYYY:MM:DD hh:mm:ss').toDate();
    }
    $('input[name=\'documentCreationDate[' + allMetaData.name + ']\']').datetimepicker({
        format: 'DD.MM.YYYY HH:mm', defaultDate: date, showTodayButton: true, showClose: true, locale: 'de',
    });
}

function loadAllFindings() {
    loadInBlock('AllFindings', '.FindingsBlock', '/' + appLocation + 'getAllFindings');
}

function addPatientRecordType() {
    const name = $("#customPatientRecordType").val();
    const id = $("#customPatientRecordTypeId").val();
    const endpoint = id ? "updatePatientRecordType/" + id : "createPatientRecordType"
    let data = {name}
    $.ajax({
        url: '/' + appLocation + endpoint, context: document.body, type: 'post', data: data
    }).done(() => {
        $("#customPatientRecordType").val("")
        $("#customPatientRecordTypeId").val("")
        actionSuccess();
        load('CustomPatientRecordTypes', null, true);
    }).fail(() => {
        actionFail();
    });
}

function addPatientRecordTypeInput(event) {
    if (event.keyCode != 13) return;
    addPatientRecordType();
}

function updatePatientRecordType(id, name) {
    $("#customPatientRecordTypeId").val(id);
    $("#customPatientRecordType").val(name);
}

function deletePatientRecordType(id) {
    var message = "Wenn Sie diese Protokoll-Kategorie löschen, werden alle bestehenden Protokolleinträge dieser Kategorie der Standard-Kategorie <strong>Anderes</strong> zugeordnet."
    customConfirm('Bestätigen', message, function () {
        $.ajax({
            url: '/' + appLocation + 'deletePatientRecordType/' + id, context: document.body, type: 'delete',
        }).done(() => {
            actionSuccess();
            load('CustomPatientRecordTypes', null, true);
        }).fail(() => {
            actionFail();
        });
    });
}

var BASE64_MARKER = ';base64,';

function convertDataURIToBinary(dataURI) {
    var base64Index = dataURI.indexOf(BASE64_MARKER) + BASE64_MARKER.length;
    var base64 = dataURI.substring(base64Index);
    var raw = window.atob(base64);
    var rawLength = raw.length;
    var array = new Uint8Array(new ArrayBuffer(rawLength));

    for (var i = 0; i < rawLength; i++) {
        array[i] = raw.charCodeAt(i);
    }
    return array;
}

function loadClinicalExaminationInDiv(genericDocumentTypeId, genericDocumentId, patientId) {
    const form = $('#clinicalExaminationDiv' + genericDocumentTypeId + " form:first")[0];
    doPendingChangesCheck(form, true, function ({save}) {
        if (form && save) $(form).submit();
        var element = '#clinicalExaminationDiv' + genericDocumentTypeId;
        showLoaderIn(element);
        $(element).load(`/${appLocation}getGenericDocumentFormForExistingDocument/${genericDocumentId}`, () => {
            setComboBoxValue('genericDocumentFormPatient', patientId);
            registerGenericDocumentFormSubmitButton(patientId, genericDocumentId, genericDocumentTypeId, null);
            focusFirstInput('genericQuestionnaireInput');
        });
        // we're unloading the form, so we should stop observing it
        observeForm(form, false);
    });
}

function deleteClinicalExamination(id, typeId, patientId) {
    var message = "Sind Sie sicher, dass Sie diese Untersuchung löschen möchten?"
    customConfirm('Bestätigen', message, function () {
        $.ajax({
            url: '/' + appLocation + 'deleteDocuments', data: {id: id}, context: document.body, type: 'post',
        }).done(() => {
            actionSuccess();

            var tabId = 'clinicalExaminationTab' + typeId;
            loadPatientView(patientId, "ClinicalExaminations", currentPage, null, function () {
                showTabInPatientViewModule("clinicalExaminationTabList", tabId);
            });

        }).fail(() => {
            actionFail();
        });
    });
}

function physicallyDeleteDocumentById(id, patientId,) {
    customConfirm("ACHTUNG! Bitte bestätigen", "Sind Sie sicher, dass Sie dieses Dokument inkl. der zugehörigen Datei unwiderruflich löschen möchten? Entgegen der normalen Löschfunktion, kann dieses Dokument nicht wiederhergestellt werden, auch nicht zu forensischen Zwecken. Es ist lediglich sichtbar, dass ein Dokument gelöscht wurde. Bitte stellen Sie sicher, dass dies nur für fehlerhafte oder unrelevante Dokumente ausgeführt wird!", function () {
        if (!patientId) {
            patientId = -1;
        }
        showLoaderIn(".DocumentsBlock");
        $.ajax({
            url: "/" + appLocation + "physicallyDeleteDocument", context: document.body, type: "post", data: {id: id},
        })
            .done(function () {
                actionSuccess();
                refreshDocumentsForPatient(patientId);
            })
            .fail(function () {
                actionFail("Der Eintrag konnte nicht gelöscht werden.");
            });
    });
}

function cancelERecipe(documentId, patientId,) {
    customConfirm("ACHTUNG! Bitte bestätigen", "Sind Sie sicher, dass Sie dieses Rezept stornieren wollen!", function () {
        if (!patientId) {
            patientId = -1;
        }
        showLoaderIn(".DocumentsBlock");
        $.ajax({
            url: `/${appLocation}recipe/${documentId}/cancel`, context: document.body, type: "PATCH",
        }).done(function () {
            actionSuccess();
            refreshDocumentsForPatient(patientId);
        }).fail(function () {
            actionFail("Der Eintrag konnte nicht gelöscht werden.");
        });
    });
}

function showABSRequestStatus(absRequestIds, patient) {
    showECardModal(false, {
        callback: () => {
            $("#eCardModal .nav-item").removeClass("active");
            $("#eCardModal .tab-pane").removeClass("active");
            $("#abs-requests-actions-tab-item").addClass("active");
            $("#abs-requests").addClass("active");
            refreshABSRequestsTable(absRequestIds, patient);
        }
    });
}

function toggleCheckBox(checkboxId) {
    const checkbox = $(`#${checkboxId}`);
    if (checkbox) checkbox.attr("checked", !checkbox.attr("checked"))
}

function selectAll(className) {
    const checkboxes = $(`.${className}`);
    checkboxes.attr("checked", !checkboxes.attr("checked"));
}

function loadExaminationResults(patientId, documentId) {
    showLoaderIn(".documentExaminationsList");
    let from = moment($(`#examinations-from-chooser`).val()).toDate();
    let until = moment($(`#examinations-until-chooser`).val()).toDate();
    const updateDocumentId = documentId ? `?documentId=${documentId}` : "";

    $(".documentExaminationsList").each((element, data) => {

        const requirementId = $(data).attr("data-content")
        $(data).load(`/${appLocation}loadExaminationResults/${requirementId}/${patientId}${updateDocumentId}`, {
            from, until
        }, (response, status, xhr) => {
            $(".document-examinations-container").show();
            if (status === "error") {
                hideLoaderIn(element);
            }
        });
    })

}

//genericFunctionName
function calculateGenericFunction(questionId, paramQuestionIdArray, genericFunctionName) {
    var valueArray = [];

    paramQuestionIdArray.forEach(paramQuestionId => {
        //CAVE: only numbers supported so far!
        valueArray.push(Number($('#questionAnswerValues_' + paramQuestionId).val()));
    })

    if (genericFunctionName.startsWith('evaluateExpression')) {
        const regex = /q\((\d*)\)/g
        let expression = genericFunctionName.match(/evaluateExpression\((.*)\)/)[1];
        const matches = expression.matchAll(regex);
        if (matches) {
            Array.from(matches).map(it => {
                const value = $(`#questionAnswerValues_${it[1]}`).val()
                expression = expression.replace(it[0], value)
            });
        }
        try {
            return eval(expression)
        } catch (syntaxEception) {
            return "0";
        }
    }
    if (genericFunctionName === 'sumOfValues') {
        return sumOfValues(valueArray);
    } else if (genericFunctionName === 'bmi') {
        debugger
        return bmi(valueArray);
    } else if (genericFunctionName === 'observeValue') {
        return observeValue(valueArray);
    } else alert("unsupported generic document function: " + genericFunctionName);
}

function sumOfValues(valueArray) {
    return valueArray.reduce((accumulator, currentValue) => accumulator + currentValue, 0);
}

function bmi(valueArray) {
    if (valueArray.length !== 2) {
        alert("bmi must be calculated from two values")
    }

    //param1 = Körpergewicht in kg
    //param2 = Körpergröße in cm
    var weight = valueArray[0];
    var height = valueArray[1];

    //BMI = Körpergewicht in kg : (Körpergröße in m)²
    var bmi = weight / (height / 100 * height / 100)
    return bmi.toFixed(2);
}

function observeValue(valueArray) {
    if (valueArray.length !== 1) {
        alert("there must be exactly 1 question to observe")
    }
    return valueArray[0];
}

function doPendingChangesCheck(form, canSave, action) {
    if (formChangesPending(form))
        customConfirm(
            "Sie haben ungespeicherte Änderungen.",
            canSave
                ? "Möchten sie diese Speichern oder verwerfen?"
                : "Möchten sie diese Aktion trotzdem ausführen?",
            canSave ? () => action({save: true}) : null, () => action({save: false}),
            canSave ? "speichern" : "abbrechen",
            "Änderungen verwerfen"
        )
    else action({save: false});
}

function showAnswerHistory(questionId, patientId, documentId = null) {
    documentId = documentId ? "&documentType=" + documentId : "";

    jsPanel.create({
        headerTitle: "Verlauf",
        contentSize: {width: "75%", height: "75%"},
        borderRadius: 3,
        closeOnEscape: true,
        headerLogo: '<span style="padding:10px" class="glyphicon glyphicon-time"></span>',
        content: `<img style="padding:10px" src="/${appLocation}resources/images/loader.gif"/>`,
        contentFetch: {resource: "/" + appLocation + `answerHistory/${patientId}?question=${questionId}${documentId}`,},
        theme: "#f2f2f2",
    });
}

function showWidgetAnswerHistory(widgetId, patientId) {
    jsPanel.create({
        headerTitle: "Verlauf",
        contentSize: {width: "75%", height: "75%"},
        borderRadius: 3,
        closeOnEscape: true,
        headerLogo: '<span style="padding:10px" class="glyphicon glyphicon-time"></span>',
        content: `<img style="padding:10px" src="/${appLocation}resources/images/loader.gif"/>`,
        contentFetch: {resource: "/" + appLocation + `answerHistory/${patientId}?widgetType=${widgetId}`,},
        theme: "#f2f2f2",
    });
}

function manageAnswerHistorySettings(questionId) {
    $.ajax("/" + appLocation + `manageAnswerHistorySettings/${questionId}`)
        .done((response) => {
            const box = bootbox.dialog({
                message: response,
                title: "Verlauf Optionen"
            });
            $('#answerHistorySettings').submit(function (e) {
                e.preventDefault();
                $.ajax({
                    url: $(this).attr("action"),
                    context: document.body,
                    type: 'post',
                    data: $(this).serialize()
                }).done(function (response) {
                    actionSuccess();
                    box.remove(); // remove so it does not stay in dom and break the next invocation
                }).fail(function (error) {
                    actionFail();
                });
                return false;
            });
        }).fail((error) => {
        actionFail(error)
    })
}

function tcmDocExport(patientId) {
    fetch(`/${appLocation}tcmdocexport/${patientId}`)
        .then(res => res.text())
        .then(data => {
            navigator.clipboard.writeText(data);
            actionSuccess();
        });
}

function openDocumentLog(documentId) {
    jsPanel.create({
        headerTitle: "Aktionsprotokoll",
        contentSize: {width: "75%", height: "75%"},
        borderRadius: 3,
        headerLogo: '<span style="padding:10px" class="glyphicon list"></span>',
        content: `<img style="padding:10px" src="/${appLocation}resources/images/loader.gif" alt="loading..."/>`,
        contentFetch: {resource: "/" + appLocation + "documentLog/" + documentId},
        theme: "#f2f2f2",
    });
}